import React, { useEffect, useState, useRef } from "react"
import { useNavigate, useLocation, Link } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { Dropdown, DropdownButton } from 'react-bootstrap'
import { DebounceInput } from 'react-debounce-input'
import { useTranslation } from 'react-i18next'
import DatePicker from "react-datepicker"
import Select, { components } from 'react-select'
import { Modal, Form } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { useReactToPrint } from 'react-to-print';
import XLSX from 'xlsx-js-style'
import { styleExcelSheet } from 'helpers/excel'
import { Scanner } from '@yudiel/react-qr-scanner'

import { useForm, Controller } from "react-hook-form"

import Pagination from 'pages/parts/Pagination'
import TableControl from 'pages/parts/TableControl'
import PriceTag60x40 from '../priceTags/PriceTag60x40'
import PriceTag60x30 from '../priceTags/PriceTag60x30'
import PriceTag40x30 from '../priceTags/PriceTag40x30'
import PriceTag30x20 from '../priceTags/PriceTag30x20'

import { GET, PGET, POST, PUT, FILE } from 'helpers/api'
import { formatMoney, formatDateBackend, findFromArrayById, findIdFromArray, checkRole, sanitizeDocumentInPriceInput, collectDocumentsInProductErrors, validateImportFileBarcodes } from "helpers/helpers";
import ConfirmModal from "pages/parts/ConfirmModal"
import MoneyInput from 'pages/parts/MoneyInput'

function CreateUpdate() {
	const { t } = useTranslation()
	const navigate = useNavigate();
	const location = useLocation();
	const dispatch = useDispatch();
	const printRef = useRef(null);

	const reduxSettings = useSelector(state => state.settings)
	const reduxTransferData = useSelector(state => state.transferData)
	// console.log(reduxSettings);

	const canCreateProduct = checkRole('MAIN_PRODUCTS_ADD')

	const searchRef = useRef(null);

	const { register, handleSubmit, formState, control, setValue, getValues, reset } = useForm({
		mode: "onChange",
		defaultValues: {
			name: '',
			barcode: '',
			uomId: 1,
			categoryId: 2,
			modQuantity: ''
		}
	});
	const { errors } = formState

	const {
		register: register2,
		formState: { errors: errors2 },
		handleSubmit: handleSubmit2,
		reset: reset2,
	} = useForm({
		mode: "onChange",
		defaultValues: {
			name: '',
			phone: '',
		}
	});



	const currencies = [{ "id": 1, "name": "So`m" }, { "id": 2, "name": "USD" }]
	const paymentTypes = [{ 'id': 1, 'name': t('CASH') }, { 'id': 3, 'name': t('MONEY_TRANSFER') }]
	const seasons = [{ id: 0, name: t('EMPTY') }, { id: 1, name: t('SEASONAL') }, { id: 2, name: t('NOT_SEASONAL') }];
	const paids = [{ id: 1, name: t('NOT_PAID') }, { id: 2, name: t('PAID') }];

	const [pageCount, setPageCount] = useState(0)
	const [searchDataExist, setSearchDataExist] = useState(0)

	const [uoms, setUoms] = useState([]) // for instant create modal
	const [categories, setCategories] = useState([]) // for instant create modal
	const [categoriesInitial, setCategoriesInitial] = useState([])
	const [organizations, setOrganizations] = useState([])
	const [poses, setPoses] = useState([])
	const [searchData, setSearchData] = useState([])
	const [printProducts, setPrintProducts] = useState([])

	const [barcode, setBarcode] = useState(false)
	const [modalSerialNumbers, setModalSerialNumbers] = useState(false)
	const [modalProduct, setModalProduct] = useState(false)
	const [modalProductData, setModalProductData] = useState(false)
	const [modalUpdateProduct, setModalUpdateProduct] = useState(false)
	const [modalConfirm, setModalConfirm] = useState(false)
	const [modalDeleteAllConfirm, setModalDeleteAllConfirm] = useState(false)
	const [modalOrganization, setModalOrganization] = useState(false)
	const [modalTableControl, setModalTableControl] = useState(false)
	const [modalPriceTag, setModalPriceTag] = useState(false)
	const [allSelected, setAllSelected] = useState(false)
	const [expenseSetted, setExpenseSetted] = useState(false)
	// "Ustama sotish" yonidagi galochka — yoqilsa hisob teskari ishlaydi:
	// Sotish narxiga son yozilganda Kelgan narx avtomatik shakllanadi.
	const [reverseSalePrice, setReverseSalePrice] = useState(false)
	const [modalScanner, setModalScanner] = useState(false)
	const [scannerZoom, setScannerZoom] = useState(1)
	const [isMobile, setIsMobile] = useState(false)
	const [showAdditionalFields, setShowAdditionalFields] = useState(false)

	const [search, setSearch] = useState('')
	const [tasnifProductName, setTasnifProductName] = useState('')
	const [serialNumber, setSerialNumber] = useState('')

	const [totalAmount, setTotalAmount] = useState({ totalIncome: 0, totalSale: 0, totalQuantity: 0 })
	const [modalData, setModalData] = useState({})
	const [selectedItem, setSelectedItem] = useState({})

	const [readyToShowModal, setReadyToShowModal] = useState(false);
	const [data, setData] = useState({
		productList: [],
		posId: null,
		productCategoryId: null,
		paymentTypeId: 1,
		paid: 1,
		based: null,
		organizationId: null,
		currencyId: 1,
		currencyName: "",
		productSerial: false,
		importExcel: false,
		wholesalePriceMarkup: 0,
		bankPriceMarkup: 0,
		salePriceMarkup: 0,
		defaultVat: 0,
		totalAmount: 0,
		expense: '',
		error: false,
	})
	const [didoxInvoiceId, setDidoxInvoiceId] = useState(null)

	// Pre-fill the form from a synced Didox incoming invoice (opened via the Didox inbox).
	// Nothing is sent until the operator reviews and submits the normal create.
	useEffect(() => {
		const prefill = location.state?.didoxPrefill
		if (!prefill) return
		setDidoxInvoiceId(prefill.incomingInvoiceId || null)
		setData(prev => ({
			...prev,
			posId: prefill.posId ?? prev.posId,
			organizationId: prefill.organizationId ?? prev.organizationId,
			currencyId: prefill.currencyId ?? prev.currencyId,
			paymentTypeId: prefill.paymentTypeId ?? prev.paymentTypeId,
			inNumber: prefill.inNumber ?? '',
			note: prefill.note ?? '',
			productList: (prefill.productList || []).map(p => ({
				productId: p.productId ?? null,
				productDB: !!p.productDB,
				productName: p.productName,
				name: p.productName,
				barcode: p.barcode ?? '',
				productBarcode: p.barcode ?? '',
				gtin: p.gtin ?? '',
				productCategory: p.productCategory ?? null,
				uomId: p.uomId ?? 1,
				quantity: p.quantity ?? 0,
				price: p.price ?? '',
				originalPrice: p.originalPrice ?? p.price ?? '',
				salePrice: p.salePrice ?? '',
				wholesalePrice: '',
				bankPrice: '',
				vat: p.vat ?? 0,
				totalAmount: p.totalAmount ?? 0,
				serialNumbers: [],
				checked: false,
			})),
		}))
	}, [location.state]) // eslint-disable-line react-hooks/exhaustive-deps

	const [cashbox] = useState({
		cashboxId: 11,
		defaultCurrency: 'So`m',
		hidePriceIn: true,
		loyaltyApi: "",
		posId: 15,
		posName: "idokon test",
		saleMinus: false,
	})
	const [selectedPriceTag, setSelectedPriceTag] = useState({
		'priceTag60x40_1': false,
		'priceTag60x30_1': false,
		'priceTag60x30_2': false,
		'priceTag60x30_3': false,
		'priceTag60x30_4': false,
		'priceTag60x30_5': false,
		'priceTag60x30_6': false,
		'priceTag60x30_7': false,
		'priceTag60x30_8': false,
		'priceTag60x30_9': false,
		'priceTag40x30_1': false,
		'priceTag40x30_2': false,
		'priceTag40x30_3': false,
		'priceTag30x20_1': false,
		'priceTag30x20_2': false,
		'priceTag30x20_3': false,
		'priceTag30x20_4': false,
	})

	async function searchOfdProduct() {
		const response = await GET('/services/web/api/get-ofd-product?barcode=' + getValues('barcode'), {}, { loader: true })
		if (response && response.gtin) {
			setValue('name', response.name)
			setValue('gtin', response.gtin)
		} else {
			return toast.error('ИКПУ ' + t('NOT_FOUND'))
		}
	}

	function onChangePrice() {
		var dataCopy = { ...data }
		if (Number(dataCopy.expense)) {
			if (!expenseSetted) {
				for (let i = 0; i < dataCopy?.productList?.length; i++) {
					var percent = (Number(dataCopy.productList[i].originalPrice) * 100) / Number(totalAmount.totalIncome);
					if (!reduxSettings.documentsInCalculationByAmount) {
						dataCopy.productList[i].price = Number(dataCopy.productList[i].originalPrice + (dataCopy.expense * (percent / 100))).toFixed(2)
					}
				}
				setExpenseSetted(true)
				setData(dataCopy)
				countTotalAmount(undefined, false, dataCopy)
			}
		} else {
			for (let i = 0; i < dataCopy?.productList?.length; i++) {
				if (!reduxSettings.documentsInCalculationByAmount) {
					dataCopy.productList[i].price = dataCopy.productList[i].originalPrice
				}
			}
			setData(dataCopy)
			setExpenseSetted(false)
			countTotalAmount(undefined, false, dataCopy)
		}
	}

	const selectPriceTag = (selectedKey) => {
		var selectedPriceTagCopy = { ...selectedPriceTag }
		for (const [key] of Object.entries(selectedPriceTagCopy)) {
			if (key === selectedKey) {
				selectedPriceTagCopy[key] = true
			} else {
				selectedPriceTagCopy[key] = false
			}
		}
		setSelectedPriceTag(selectedPriceTagCopy)
	}

	function openPriceTagModal() {
		var dataCopy = { ...data }
		for (let i = 0; i < dataCopy.productList.length; i++) {
			dataCopy.productList[i]['printQuantity'] = dataCopy.productList[i]['quantity']
		}
		setData(dataCopy)
		setModalPriceTag(true)
	}

	function prevHandlePrint() {
		var copyArr = [...data.productList]
		var prepareProducts = []
		for (let i = 0; i < copyArr.length; i++) {
			if (data.productList[i].checked) {
				copyArr[i].productName = copyArr[i].name
				copyArr[i].posName = cashbox.posName
				copyArr[i].productName = copyArr[i].name
				for (let j = 0; j < copyArr[i]['printQuantity']; j++) {
					prepareProducts.push(copyArr[i])
				}
			}
		}
		setPrintProducts(prepareProducts)
		setTimeout(() => {
			handlePrint()
		}, 300)
	}

	const handlePrint = useReactToPrint({
		content: () => printRef.current
	});


	async function createUpdate(e) {
		e.preventDefault();
		var sendData = { ...data }
		sendData.totalAmount = totalAmount.totalIncome
		sendData.productSerial = false
		for (let i = 0; i < sendData.productList.length; i++) {
			sendData.productList[i]['totalAmount'] = sendData.productList[i]['price'] * sendData.productList[i]['quantity']
			if (sendData.productList[i]['serialNumbers'].length > 0) {
				sendData.productSerial = true
			}
		}

		const validationErrors = collectDocumentsInProductErrors(
			sendData.productList,
			reduxSettings.tableDocumentsInCreate,
			t
		)
		if (validationErrors.length) {
			toast.error(t('ERROR') + ': ' + validationErrors[0], { autoClose: 8000 })
			return
		}

		var response;
		if (sendData.id) {
			response = await PUT('/services/web/api/documents-in', sendData, { loader: true })
		} else {
			response = await POST('/services/web/api/documents-in', sendData, { loader: true })
		}

		if (response) {
			dispatch({ type: 'SET_DOCUMENT_IN_CREATE_DATA', payload: {} })
			// flag the source Didox invoice as imported so the inbox can mark it done
			if (didoxInvoiceId && !sendData.id) {
				await POST(`/services/web/api/didox/incoming-invoices/${didoxInvoiceId}/mark-imported`, {})
			}
			navigate('/documents-in')
		}
	}

	var tasnifLang;
	selectProductsLang();
	function selectProductsLang() {
		if (localStorage.getItem('lang') == 'ru') {
			tasnifLang = 'ru'
		} else if (localStorage.getItem('lang') == 'uz-Latn-UZ') {
			tasnifLang = 'uz_latn'
		} else {
			tasnifLang = 'uz_cyrl'
		}
	}

	useEffect(() => {
		if (readyToShowModal) {
			if (search && tasnifProductName) {
				showProductCreateModal(true);
			} else {
				alert("Please make sure both the barcode and name fields are filled out.");
			}
			// Reset the readyToShowModal state
			setReadyToShowModal(false);
		}
	}, [readyToShowModal, search, tasnifProductName]);

	async function searchProduct(value, type = '') {
		setSearchDataExist(0)

		// faqat type "add" bo'lmasa setSearch ishlaydi
		if (type !== 'add') {
			setSearch(value)
		}

		if (value.length === 0) {
			setSearchData([])
			setSearchDataExist(0)
			return
		}

		const response = await PGET(
			"/services/web/api/product-in-helper",
			{ 'name': value, 'posId': data.posId, 'barcode': barcode, 'currencyId': data.currencyId },
			{ loader: true }
		)
		setPageCount(Math.ceil(response.headers['x-total-count'] / 20))

		let dataCopy = { ...data }
		let responseCopy = [...response.data]
		let responseCopy2 = [...response.data]

		// mavjud productlarni filtrlash
		for (let i = 0; i < responseCopy.length; i++) {
			for (let j = 0; j < dataCopy.productList.length; j++) {
				if (responseCopy[i]['productId'] === dataCopy.productList[j]['productId']) {
					if (responseCopy.length === 1) {
						setSearchDataExist(2)
						if (type !== 'add') setSearch('')
						return;
					}
					responseCopy2 = responseCopy2.filter(e => e.productId !== dataCopy.productList[j]['productId'])
				}
			}
		}

		// agar localda yo'q bo'lsa, tashqi tasnifdan qidirish; keyin OFD'ga
		if (responseCopy2.length === 0) {
			const rawValue = value;
			let zeroCount = 13 - value.length;
			const paddedValue = zeroCount > 0 ? '0'.repeat(zeroCount) + value : value;

			let matched = null
			try {
				const responseAll = await fetch(
					`https://tasnif.soliq.uz/api/cls-api/elasticsearch/search?lang=${tasnifLang}&search=${rawValue}`
				);
				const responseTasnif = await responseAll.json();
				const tasnifMatch = (responseTasnif.data || []).find(x =>
					x.internationalCode === rawValue || x.internationalCode === paddedValue
				)
				if (tasnifMatch) {
					matched = { barcode: tasnifMatch.internationalCode, name: tasnifMatch.name, gtin: tasnifMatch.mxikCode }
				}
			} catch (e) { /* ignore; try OFD */ }

			if (!matched) {
				try {
					const ofd = await GET(`/services/web/api/get-ofd-product?barcode=${rawValue}`, {}, { loader: false })
					if (ofd && ofd.barcode && ofd.gtin &&
						(ofd.barcode === rawValue || ofd.barcode === paddedValue)) {
						matched = { barcode: ofd.barcode, name: ofd.name, gtin: ofd.gtin }
					}
				} catch (e) { /* ignore; nothing to match */ }
			}

			if (matched) {
				if (type !== 'add') {
					setSearch(matched.barcode)
					setTasnifProductName(matched.name)
				}
				setValue('barcode', matched.barcode)
				setValue('name', matched.name)
				setValue('gtin', matched.gtin)
				setReadyToShowModal(true);
			}

			setSearchDataExist(1)
			return
		}

		// faqat bitta topilsa va barcode bo'lsa
		if (/^\d+$/.test(value) && responseCopy2.length === 1) {
			setSearchData(responseCopy2)
			if (responseCopy2[0]['productShow']) {
				// faqat type "add" bo'lmaganda avtomatik qo'shadi
				if (type !== 'add') {
					addToList(0, responseCopy2, true)
					setSearch('')
				}
			}
		} else {
			setSearchData(responseCopy2)
		}
	}



	function handleExpDateChange(date, index) {
		var dataCopy = { ...data }
		dataCopy.productList[index]['expDate'] = formatDateBackend(date)
		setData(dataCopy)
	}

	function handleProductListChange(e, index) {
		var dataCopy = { ...data }
		const priceFields = ['price', 'salePrice', 'wholesalePrice', 'bankPrice', 'totalPrice']
		const isPriceField = priceFields.includes(e.target.name)

		let value = e.target.value
		if (isPriceField) {
			value = sanitizeDocumentInPriceInput(value)
		} else {
			value = value.replace(/,/g, '.')
			value = value.replace(/[^0-9.]/g, '')
			const dotCount = (value.match(/\./g) || []).length
			if (dotCount > 1) {
				const firstDotIndex = value.indexOf('.')
				value = value.substring(0, firstDotIndex + 1) + value.substring(firstDotIndex + 1).replace(/\./g, '')
			}
		}	
		dataCopy.productList[index][e.target.name] = value

		if (e.target.name === 'vat') {
			if (dataCopy.productList[index][e.target.name] > 12) {
				dataCopy.productList[index][e.target.name] = 0
			}
		}

		if (e.target.name === 'price') {
			dataCopy.productList[index].originalPrice = Number(value)
		}

		// Teskari hisob: galochka belgilangan bo'lsa, Sotish narxiga son yozilganda
		// Kelgan narx = Sotish narxi / (1 + Ustama sotish %) bo'yicha avtomatik shakllanadi.
		if (e.target.name === 'salePrice' && reverseSalePrice) {
			const markup = Number(dataCopy.salePriceMarkup) || 0
			const sp = Number(value)
			if (Number.isFinite(sp) && sp > 0) {
				const computed = Number((sp / (1 + markup / 100)).toFixed(2))
				dataCopy.productList[index].price = computed
				dataCopy.productList[index].originalPrice = computed
				// Ulgurji va transfer narxlarini ham yangi Kelgan narxdan shakllantiramiz.
				const wMarkup = Number(dataCopy.wholesalePriceMarkup) || 0
				const bMarkup = Number(dataCopy.bankPriceMarkup) || 0
				dataCopy.productList[index].wholesalePrice = Number((computed + computed * (wMarkup / 100)).toFixed(2))
				dataCopy.productList[index].bankPrice = Number((computed + computed * (bMarkup / 100)).toFixed(2))
			} else {
				dataCopy.productList[index].price = ''
				dataCopy.productList[index].originalPrice = 0
				dataCopy.productList[index].wholesalePrice = ''
				dataCopy.productList[index].bankPrice = ''
			}
		}

		if (reduxSettings.documentsInCalculationByAmount) {
			if (e.target.name === 'totalPrice' || e.target.name === 'quantity') {
				dataCopy.productList[index].price = Number(dataCopy.productList[index].totalPrice) / (dataCopy.productList[index].quantity ?? 0)
				dataCopy.productList[index].salePrice = Number(dataCopy.productList[index].totalPrice) / (dataCopy.productList[index].quantity ?? 0)
				dataCopy.productList[index].bankPrice = Number(dataCopy.productList[index].totalPrice) / (dataCopy.productList[index].quantity ?? 0)
				dataCopy.productList[index].wholesalePrice = Number(dataCopy.productList[index].totalPrice) / (dataCopy.productList[index].quantity ?? 0)
			}
		}

		setData(dataCopy)

		if (e.target.name === 'quantity') {
			countTotalAmount(index, false)
		}
		if (e.target.name === 'price') {
			countTotalAmount(index)
		}
		if (e.target.name === 'salePrice') {
			countTotalAmount(index, false)
		}
		if (e.target.name === 'totalPrice') {
			countTotalAmount(index, false)
		}
	}

	function countTotalAmount(index, callSetPrice = true, newData) {
		if (index !== undefined && callSetPrice) setPrices(index)

		var dataCopy = { ...data }
		if (newData) {
			dataCopy = newData
		}
		var temporaryTotalQuantity = 0
		var temporaryTotalIncome = 0
		var temporaryTotalSale = 0

		for (let i = 0; i < dataCopy.productList?.length; i++) {
			if (dataCopy.productList[i]['price'] && dataCopy.productList[i]['quantity']) {
				temporaryTotalQuantity += Number(dataCopy.productList[i]['quantity'])
				temporaryTotalIncome += dataCopy.productList[i]['price'] * dataCopy.productList[i]['quantity']
				temporaryTotalSale += dataCopy.productList[i]['salePrice'] * dataCopy.productList[i]['quantity']
			}
		}

		setTotalAmount({ totalIncome: temporaryTotalIncome, totalSale: temporaryTotalSale, totalQuantity: temporaryTotalQuantity })
	}

	function setPrices(index) {
		var dataCopy = { ...data }
		if (dataCopy.productList[index]['price'] !== "") {
			dataCopy.productList[index]['wholesalePrice'] = Number(dataCopy.productList[index]['price']) + Number((dataCopy.productList[index]['price'] * (dataCopy.wholesalePriceMarkup / 100)))
			dataCopy.productList[index]['bankPrice'] = Number(dataCopy.productList[index]['price']) + Number((dataCopy.productList[index]['price'] * (dataCopy.bankPriceMarkup / 100)))
			dataCopy.productList[index]['salePrice'] = Number(dataCopy.productList[index]['price']) + Number((dataCopy.productList[index]['price'] * (dataCopy.salePriceMarkup / 100)))
		} else {
			dataCopy.productList[index]['wholesalePrice'] = ""
			dataCopy.productList[index]['bankPrice'] = ""
			dataCopy.productList[index]['salePrice'] = ""
		}
		setData(dataCopy)
	}

	function handleAllSelected() {
		var dataCopy = { ...data }
		if (dataCopy.productList) {
			for (let i = 0; i < dataCopy.productList.length; i++) {
				if (allSelected) {
					dataCopy.productList[i].checked = false;
				} else {
					dataCopy.productList[i].checked = true;
				}
			}
		}
		if (allSelected) {
			setPrintProducts([])
		} else {
			setPrintProducts(dataCopy.productList)
		}
		setData({ ...data, dataCopy })
		setAllSelected(!allSelected)
	}

	function handleChange(index) {
		var dataCopy = { ...data }
		var printProductsCopy = [...printProducts]
		dataCopy.productList[index].checked = !dataCopy.productList[index].checked
		dataCopy.productList[index].productName = dataCopy.productList[index].name
		if (dataCopy.productList[index].checked) {
			printProductsCopy.push(dataCopy.productList[index])
		} else {
			if (dataCopy.productList.length === 1) {
				setModalPriceTag(false)
				setPrintProducts([])
				return;
			}
			var inProductIndex = printProductsCopy.findIndex(item => item.productId === dataCopy.productList[index].productId)
			if (index >= 0) {
				printProductsCopy.splice(inProductIndex, 1)
			}

		}
		setPrintProducts(printProductsCopy)
		setData(dataCopy)
	}

	function addToList(index, arr = [], putCursor = false) {
		var searchDataCopy;
		if (arr.length > 0) {
			searchDataCopy = arr
		} else {
			searchDataCopy = [...searchData]
		}

		if (!searchDataCopy[index].price) {
			searchDataCopy[index].price = ''
		}
		if (!searchDataCopy[index].wholesalePrice) {
			searchDataCopy[index].wholesalePrice = ''
		}
		if (!searchDataCopy[index].bankPrice) {
			searchDataCopy[index].bankPrice = ''
		}
		if (!searchDataCopy[index].salePrice) {
			searchDataCopy[index].salePrice = ''
		}
		if (data.defaultVat) {
			searchDataCopy[index].vat = data.defaultVat
		} else {
			searchDataCopy[index].vat = 0
		}
		if (searchDataCopy[index].originalPrice) {
			searchDataCopy[index].price = searchDataCopy[index].originalPrice
		}

		searchDataCopy[index].quantity = ''
		searchDataCopy[index].label = ''
		searchDataCopy[index].originalPrice = searchDataCopy[index].price
		searchDataCopy[index].originalSalePrice = searchDataCopy[index].salePrice
		searchDataCopy[index].originalWholesalePrice = searchDataCopy[index].wholesalePrice
		searchDataCopy[index].originalBankPrice = searchDataCopy[index].bankPrice
		searchDataCopy[index].checked = false
		searchDataCopy[index].serialNumbers = []

		var dataCopy = { ...data }
		dataCopy.productList.push(searchDataCopy[index])
		onChangePrice(data?.expense)
		setData(dataCopy)

		setTimeout(() => {
			const lastInput = document.getElementById(dataCopy.productList.length)
			lastInput?.select()
		}, 200);


		searchDataCopy.splice(index, 1)
		setSearchData(searchDataCopy)

		if (searchDataCopy.length === 0) {
			setSearch('')
		}
		searchRef.current.focus()
	}

	function deleteAllProduct() {
		var dataCopy = { ...data }
		if (printProducts.length > 0) {
			setPrintProducts([])
		}
		dataCopy.productList = []

		countTotalAmount(undefined, false)

		dataCopy.importExcel = false

		setData(dataCopy)
		dispatch({ type: 'SET_DOCUMENT_IN_CREATE_DATA', payload: {} })
		setModalDeleteAllConfirm(false)
	}

	function deleteProduct(index) {
		var dataCopy = { ...data }
		if (printProducts.length > 0) {
			var copyPrintProducts = [...printProducts]
			var printIndex = copyPrintProducts.findIndex(item => item.productId === dataCopy.productList[index].productId)
			if (printIndex >= 0) {
				copyPrintProducts.splice(printIndex, 1)
			}
			setPrintProducts(copyPrintProducts)
		}
		dataCopy.productList.splice(index, 1)


		countTotalAmount(undefined, false)

		if (dataCopy.productList.length === 0) {
			dataCopy.importExcel = false
		}
		setData(dataCopy)
	}

	function serialProductsModal(item) {
		setModalData(JSON.parse(JSON.stringify(item)))
		setModalSerialNumbers(true)
	}

	function addSerialNumber() {
		var modalDataCopy = { ...modalData }
		var unitFound = modalDataCopy.serialNumbers.find(x => x === serialNumber)

		if (!unitFound) {
			modalDataCopy.serialNumbers.push(serialNumber)
			setModalData(modalDataCopy)
			setSerialNumber('')
		}
	}

	function deleteSerialNumber(index) {
		var modalDataCopy = { ...modalData }
		modalDataCopy.serialNumbers.splice(index, 1)
		setModalData(modalDataCopy)
	}

	function saveItemSerial() {
		var dataCopy = { ...data }
		for (let i = 0; i < dataCopy.productList.length; i++) {
			if (modalData.productId === dataCopy.productList[i]['productId']) {
				dataCopy.productList[i]['serialNumbers'] = modalData.serialNumbers
				dataCopy.productList[i]['quantity'] = modalData.serialNumbers.length > 0 ? modalData.serialNumbers.length : ""
			}
		}
		setData(dataCopy)
		countTotalAmount()
		setModalSerialNumbers(false)
	}

	async function showProductCreateModal(bool) {
		if (!bool) {
			reset()
		}
		if (uoms.length === 0) {
			const response = await GET('/services/web/api/product-uom-helper')
			setUoms(response)
		}
		if (search.length > 0) {
			setValue('barcode', search)
			setValue('name', tasnifProductName)
		} else {
			setValue('barcode', '')
			setValue('name', '')
		}
		setModalProduct(bool)
	}

	async function showProductUpdateModal(bool, index) {
		if (bool) {
			var response = await GET(`/services/web/api/product/${data.productList[index]['productId']}`, selectedItem, { loader: true })
			response.index = index
			setSelectedItem(response)
		} else {
			setSelectedItem({})
		}
		setModalUpdateProduct(bool)
	}

	async function changeProduct(e) {
		e.preventDefault()

		var dataCopy = { ...data }
		await PUT('/services/web/api/product', selectedItem, { loader: true })
		dataCopy.productList[selectedItem.index]['name'] = selectedItem.name
		setData(dataCopy)
		showProductUpdateModal(false)
	}

	function showOrganizationCreateModal(bool) {
		if (!bool) {
			reset2()
		}

		setModalOrganization(bool)
	}

	function handleSelectOrganization(option) {
		if (option.id === -1) {
			showOrganizationCreateModal(true)
		} else {
			setData({ ...data, 'organizationId': option.id, 'organizationDate': option.returnDay })
		}
	}

	function handleChangeProductData(e) {
		var documentInCreateProductCopy = { ...reduxTransferData['documentInCreateProduct'] }
		documentInCreateProductCopy[e.target.name] = e.target.checked
		dispatch({ type: 'SET_DOCUMENT_IN_CREATE_PRODUCT', payload: documentInCreateProductCopy })
	}

	function showProductDataModal() {
		setModalProductData(true);
		showProductCreateModal(false);
	}

	function closeProductDataModal() {
		setModalProductData(false);
		showProductCreateModal(true);
	}

	async function createProduct(validatedData) {
		if (reduxSettings.ofd) {
			if (validatedData.gtin.length === 0) {
				return toast.error('ИКПУ ' + t('required'))
			}
			if (validatedData.gtin.split('').every(char => char === validatedData.gtin[0])) {
				return toast.error('ИКПУ ' + t('ERROR'))
			}
		}
		const response = await POST('/services/web/api/product-instant-create', validatedData, { loader: true })
		var product = response.data
		if (response) {
			product.price = ''
			product.wholesalePrice = ''
			product.bankPrice = ''
			product.salePrice = ''
			product.quantity = ''
			product.label = ''
			product.serialNumbers = []
			if (data.defaultVat) {
				product.vat = data.defaultVat
			} else {
				product.vat = 0
			}

			var dataCopy = { ...data }
			var exist = false
			for (let i = 0; i < dataCopy.productList.length; i++) {
				if (
					product.productId ===
					dataCopy.productList[i]['productId']
				) {
					exist = true
				}
			}

			if (!exist) {
				dataCopy.productList.push(product)
				setData(dataCopy)
				setTimeout(() => {
					const byId = document.getElementById(dataCopy.productList.length)
					byId?.select()
				}, 200);
			} else {
				toast.error(t('ERROR') + ': ' + t('PRODUCT_IN_LIST'))
			}

			showProductCreateModal(false)
		}
	}

	async function createOrganization(validatedData) {
		validatedData.phone = '998' + validatedData.phone
		const response = await POST('/services/web/api/organization-instant-create', validatedData, { loader: true })
		if (response) {
			var organizationsCopy = [...organizations]
			organizationsCopy.push(response.data)

			setOrganizations(organizationsCopy)
			setData({ ...data, 'organizationId': response.data.id })
			showOrganizationCreateModal(false)
		}
	}

	async function parseAndValidateFile(e) {
		const posId = data.posId != null ? String(data.posId) : ''
		const paymentTypeId = data.paymentTypeId != null ? String(data.paymentTypeId) : ''
		const organizationId = data.organizationId != null ? String(data.organizationId) : ''
		const currencyId = data.currencyId != null ? String(data.currencyId) : ''
		if (!posId || !paymentTypeId || !organizationId || !currencyId) {
			toast.warning(t('FILL_REQUIRED_FIELDS'))
			return null
		}
		const file = e.target.files[0]
		if (!file) return null

		const { errors } = await validateImportFileBarcodes(file, XLSX)
		if (errors.length) {
			const msg = errors.slice(0, 6).map(er =>
				`${t('ROW')} ${er.rowNum}${er.productName ? ` (${er.productName})` : ''} — ${er.columnName}: "${er.value}"`
			).join('; ')
			toast.error(t('IMPORT_INVALID_BARCODE') + ': ' + msg, { autoClose: 12000 })
			return null
		}

		let rows
		try {
			rows = await parseImportWorkbook(file)
		} catch (err) {
			toast.error(t('IMPORT_FILE_READ_ERROR') || 'Could not read the file')
			return null
		}
		if (!rows.length) {
			toast.warning(t('IMPORT_EMPTY_FILE') || 'No rows to import')
			return null
		}

		return { file, posId, paymentTypeId, organizationId, currencyId, rows }
	}

	async function resolveAndValidateRows(rows) {
		const uniqueBarcodes = Array.from(new Set(rows.map(r => r.parentBarcode).filter(Boolean)))
		let lookups
		try {
			lookups = await Promise.all(
				uniqueBarcodes.map(bc =>
					PGET('/services/web/api/product-in-helper', {
						name: bc,
						barcode: true,
						posId: data.posId,
						currencyId: data.currencyId,
					}, { loader: true }).then(resp => ({ bc, products: resp?.data || [] }))
				)
			)
		} catch (err) {
			toast.error(t('IMPORT_LOOKUP_FAILED') || 'Barcode lookup failed')
			return null
		}

		const resolved = new Map()
		for (const { bc, products } of lookups) {
			const match = products.find(p => p.barcode === bc) || products[0]
			if (match) resolved.set(bc, match)
		}

		const problems = []
		for (const row of rows) {
			if (!resolved.has(row.parentBarcode)) {
				problems.push(`${t('ROW')} ${row.rowNum} (${row.parentBarcode}) — ${t('IMPORT_ERR_BARCODE_NOT_FOUND') || 'barcode not found'}`)
				continue
			}
			const base = resolved.get(row.parentBarcode)

			if (base.productShow === false) {
				problems.push(`${t('ROW')} ${row.rowNum} (${row.parentBarcode}) — ${t('IMPORT_ERR_OTHER_CURRENCY') || 'already received in another currency'}`)
				continue
			}
			if (row.quantityCellEmpty) {
				problems.push(`${t('ROW')} ${row.rowNum} (${row.parentBarcode}) — ${t('IMPORT_ERR_QUANTITY_MISSING') || 'quantity is required'}`)
				continue
			}
			if (row.quantity < 0) {
				problems.push(`${t('ROW')} ${row.rowNum} (${row.parentBarcode}) — ${t('IMPORT_ERR_QUANTITY_NEGATIVE') || 'quantity cannot be negative'}`)
				continue
			}
			if (row.vat !== '' && row.vat != null && Number(row.vat) > 12) {
				problems.push(`${t('ROW')} ${row.rowNum} (${row.parentBarcode}) — ${t('IMPORT_ERR_VAT_TOO_HIGH') || 'VAT exceeds 12%'}`)
			}

			row.effectivePrice = row.price > 0 ? row.price : (Number(base.price) || 0)
			row.effectiveWholesale = row.wholesalePrice > 0 ? row.wholesalePrice : (Number(base.wholesalePrice) || 0)
			row.effectiveSale = row.salePrice > 0 ? row.salePrice : (Number(base.salePrice) || 0)

			if (row.effectiveWholesale > 0 && row.effectivePrice > row.effectiveWholesale) {
				problems.push(`${t('ROW')} ${row.rowNum} — ${t('IMPORT_ERR_PRICE_WHOLESALE') || 'price > wholesale'}`)
			}
			if (row.effectiveSale > 0 && row.effectivePrice > row.effectiveSale) {
				problems.push(`${t('ROW')} ${row.rowNum} — ${t('IMPORT_ERR_PRICE_SALE') || 'price > sale'}`)
			}
		}

		if (problems.length) {
			const head = problems.slice(0, 6).join('\n')
			const tail = problems.length > 6 ? ` …(+${problems.length - 6})` : ''
			toast.error(`${t('IMPORT_REJECTED') || 'Import rejected'}:\n${head}${tail}`, { autoClose: 15000 })
			return null
		}

		return { resolved }
	}

	async function importFromExel(e) {
		try {
			const parsed = await parseAndValidateFile(e)
			if (!parsed) return
			const { rows } = parsed
			const resolvedResult = await resolveAndValidateRows(rows)
			if (!resolvedResult) return
			const { resolved } = resolvedResult

			const dataCopy = { ...data, productList: [...(data.productList || [])] }
			const existing = new Set(dataCopy.productList.map(p => p.barcode))
			let added = 0
			const asInput = v => (v > 0 ? v : '')
			for (const row of rows) {
				if (existing.has(row.parentBarcode)) continue
				const base = resolved.get(row.parentBarcode)
				const price = asInput(row.effectivePrice)
				const wholesalePrice = asInput(row.effectiveWholesale)
				const salePrice = asInput(row.effectiveSale)
				const bankPrice = asInput(Number(base.bankPrice) > 0 ? Number(base.bankPrice) : row.effectiveWholesale)
				dataCopy.productList.push({
					...base,
					quantity: row.quantity,
					price,
					wholesalePrice,
					salePrice,
					bankPrice,
					vat: row.vat !== '' && row.vat != null ? row.vat : (data.defaultVat || 0),
					expDate: row.expDate || null,
					gtin: row.gtin || base.gtin || '',
					artikul: row.artikul || base.artikul || '',
					childBarcodes: row.childBarcodes,
					label: '',
					originalPrice: price,
					originalSalePrice: salePrice,
					originalWholesalePrice: wholesalePrice,
					originalBankPrice: bankPrice,
					checked: false,
					serialNumbers: [],
				})
				existing.add(row.parentBarcode)
				added++
			}

			setData(dataCopy)
			countTotalAmount(undefined, false, dataCopy)

			const skipped = rows.length - added
			if (added === 0) {
				toast.warning(t('IMPORT_ALL_DUPLICATES') || 'All rows already in list')
			} else if (skipped > 0) {
				toast.success(`${t('IMPORT_ADDED_PARTIAL') || 'Added'}: ${added} / ${rows.length}`)
			} else {
				toast.success(`${t('IMPORT_ADDED') || 'Added'}: ${added}`)
			}
		} finally {
			e.target.value = ""
		}
	}

	async function importFromExelDirect(e) {
		try {
			const parsed = await parseAndValidateFile(e)
			if (!parsed) return
			const { file, posId, paymentTypeId, organizationId, currencyId } = parsed

			const formData = new FormData()
			formData.append('file', file)
			formData.append('posId', posId)
			formData.append('paymentTypeId', paymentTypeId)
			formData.append('organizationId', organizationId)
			formData.append('currencyId', currencyId)
			if (data.productSerial != null) formData.append('productSerial', String(data.productSerial))
			if (data.based != null) formData.append('based', String(data.based))
			for (let i = 0; i < organizations.length; i++) {
				if (organizations[i]['id'] === data.organizationId) {
					formData.append('organizationName', organizations[i]['name'])
				}
			}

			const response = await FILE("services/web/api/document-in-import", formData, { loader: true })
			if (response && response.id) {
				navigate('/documents-in/preview/' + response.id)
			}
		} finally {
			e.target.value = ""
		}
	}

	async function parseImportWorkbook(file) {
		const buf = await file.arrayBuffer()
		const wb = XLSX.read(buf, { type: 'array', cellDates: true })
		const ws = wb.Sheets[wb.SheetNames[0]]
		if (!ws || !ws['!ref']) return []
		const range = XLSX.utils.decode_range(ws['!ref'])
		const cellStr = (r, c) => {
			const cell = ws[XLSX.utils.encode_cell({ r, c })]
			return cell && cell.v != null ? String(cell.v) : ''
		}
		const cellNum = (r, c) => {
			const s = cellStr(r, c).replace(/\s+/g, '').replace(',', '.')
			if (!s) return 0
			const n = Number(s)
			return Number.isFinite(n) ? n : 0
		}
		const cellDate = (r, c) => {
			const cell = ws[XLSX.utils.encode_cell({ r, c })]
			if (!cell || cell.v == null) return null
			if (cell.v instanceof Date) return formatDateBackend(cell.v)
			const s = String(cell.v).trim()
			return s || null
		}
		const rows = []
		for (let r = range.s.r + 1; r <= range.e.r; r++) {
			const rawBarcode = cellStr(r, 2).replace(/\s+/g, '')
			if (!rawBarcode) continue
			const parts = rawBarcode.split(',').filter(Boolean)
			rows.push({
				rowNum: r + 1,
				parentBarcode: parts[0],
				childBarcodes: parts.slice(1),
				quantity: cellNum(r, 4),
				quantityCellEmpty: cellStr(r, 4).replace(/\s+/g, '') === '',
				price: cellNum(r, 5),
				wholesalePrice: cellNum(r, 6),
				salePrice: cellNum(r, 7),
				expDate: cellDate(r, 8),
				vat: cellStr(r, 9) === '' ? '' : cellNum(r, 9),
				gtin: cellStr(r, 10).replace(/\s+/g, ''),
				artikul: cellStr(r, 11).trim(),
			})
		}
		return rows
	}

	function saveToExcel(key) {
		if (Number(key) === 3) {
			// Ustunlar tartibi importDocument.xlsx shabloni bilan bir xil bo'lishi shart,
			// aks holda saqlangan faylni qayta import qilib bo'lmaydi.
			var excelHeaders = [[
				t('CATEGORY'),
				t('NAME_OF_PRODUCT'),
				t('BARCODE'),
				t('UNIT'),
				t('QUANTITY'),
				t('PRICE'),
				t('WHOLESALE_PRICE'),
				t('SALE_PRICE'),
				t('DATE'),
				t('VAT'),
				t('IKPU'),
				t('ARTIKUL'),
			]]
			const stripSpaces = v => v == null ? '' : String(v).replace(/\s+/g, '')
			const toNumber = v => {
				if (v === '' || v == null) return ''
				const n = Number(String(v).replace(/\s+/g, ''))
				return Number.isFinite(n) ? n : ''
			}
			for (let i = 0; i < data.productList.length; i++) {
				var item = data.productList[i]
				excelHeaders.push([
					item['categoryName'] || '',
					item['name'],
					stripSpaces(item['barcode']),
					item['uomId'],
					toNumber(item['quantity']),
					toNumber(item['price']),
					toNumber(item['wholesalePrice']),
					toNumber(item['salePrice']),
					item['expDate'],
					toNumber(item['vat']),
					stripSpaces(item['gtin'] || ''),
					item['artikul'] || '',
				])
			}
			const ws = XLSX.utils.aoa_to_sheet(excelHeaders);
			styleExcelSheet(ws, { plainNumbers: true })
			const wb = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
			XLSX.writeFile(wb, t('GOOD_RECEPTION') + ".xlsx");
		}
	}

	async function paginate(pageNumber) {
		const response = await PGET('/services/web/api/product-in-helper',
			{ 'name': search, 'posId': data.posId, 'barcode': barcode, 'currencyId': data.currencyId, page: pageNumber.selected, size: 20 }
		)
		setSearchData(response.data);
	}

	function generateRandomBarcode() {
		setValue('barcode', Math.floor(Math.random() * 899999 + 100000))
	}

	function setReduxProducts(data) {
		var dataCopy = { ...data }
		if (reduxTransferData.documentInCreateData?.productList && reduxTransferData.documentInCreateData?.productList?.length) {
			dataCopy = reduxTransferData.documentInCreateData
			dataCopy.productList = reduxTransferData.documentInCreateData.productList
			var arr = []
			for (let i = 0; i < dataCopy.productList?.length; i++) {
				dataCopy.productList[i].price = dataCopy.productList[i].originalPrice
				if (dataCopy.productList[i].checked) {
					arr.push(dataCopy.productList[i])
				}
			}
			setPrintProducts(arr)
			var index = arr.length - 1
			if (index >= 0) {
				dataCopy.productName = arr[index].name
				dataCopy.barcode = arr[index].barcode
				dataCopy.price = arr[index].price
				dataCopy.salePrice = arr[index].salePrice
				dataCopy.wholesalePrice = arr[index].wholesalePrice
				dataCopy.bankPrice = arr[index].bankPrice
				dataCopy.posName = cashbox.posName
			}
		}
		countTotalAmount(undefined, false, dataCopy)
		return dataCopy
	}

	async function getPoses() {
		const temporaryPoses = await GET('/services/web/api/pos-helper-all')
		if (temporaryPoses) {
			setPoses(temporaryPoses)
		}

		const temporaryOrganizations = await GET('/services/web/api/organization-helper')
		if (temporaryOrganizations) {
			var defaultOrganizations = [{ 'id': -1, 'name': t('ADD_NEW') }]
			temporaryOrganizations.forEach(element => {
				defaultOrganizations.push(element)
			});
			setOrganizations(defaultOrganizations)
		}
		var dataCopy = { ...data }
		if (temporaryOrganizations.length > 0 && temporaryPoses.length > 0) {
			if (
				reduxSettings.posId &&
				reduxSettings.organizationId &&
				findIdFromArray(temporaryPoses, reduxSettings.posId) &&
				findIdFromArray(temporaryOrganizations, reduxSettings.organizationId)
			) {
				dataCopy.posId = reduxSettings.posId
				dataCopy.organizationId = reduxSettings.organizationId
				dataCopy.currencyId = findIdFromArray(currencies, reduxSettings.currencyId) ? findIdFromArray(currencies, reduxSettings.currencyId) : 1

				dataCopy = setReduxProducts(dataCopy)
				setData(dataCopy)
				return;
			}

			dataCopy.posId = temporaryPoses[0]['id']
			dataCopy.organizationId = temporaryOrganizations[0]['id']
			dataCopy = setReduxProducts(dataCopy)
			setData(dataCopy)
		} else if (temporaryOrganizations.length > 0) {
			dataCopy.organizationId = temporaryOrganizations[0]['id']
			dataCopy = setReduxProducts(dataCopy)
			setData(dataCopy)
		}
	}

	async function getCategories() {
		const response = await GET('/services/web/api/product-category-helper')
		var arr = []
		for (let i = 0; i < response.length; i++) {
			response[i]['label'] = ' ' + response[i]['name']
			response[i].child = false;
			if (response[i].parentId !== 0) {
				const index = response.findIndex(x => x.id === response[i].parentId)
				if (index !== -1) {
					response[i].child = true;
					if (response[index].options && response[index].options.length > 0) {
						response[index].options.push(response[i])
					} else {
						response[index].options = [response[i]]
					}
				} else {
					arr.push(response[i])
				}
			} else {
				arr.push(response[i])
			}
		}
		setCategories(arr)
		setCategoriesInitial(response)
	}

	useEffect(() => {
		getPoses()
		getCategories()

		// Mobil qurilmani aniqlash
		const checkMobile = () => {
			setIsMobile(window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
		}
		checkMobile()
		window.addEventListener('resize', checkMobile)

		if (reduxSettings.categoryId) {
			setValue('categoryId', reduxSettings.categoryId)
		}
		if (!reduxTransferData?.documentInCreateProduct) {
			dispatch({
				type: 'SET_DOCUMENT_IN_CREATE_PRODUCT', payload: {
					'gtin': false,
					'seasonal': false,
					'modUomId': false,
					'modQuantity': false,
					'complete': false,
				}
			})
		}

		return () => window.removeEventListener('resize', checkMobile)
	}, []) // eslint-disable-line react-hooks/exhaustive-deps	

	useEffect(() => {
		if (reduxTransferData?.documentInCreateData?.productList?.length > 0 && data.productList.length === 0) {
			return;
		}
		dispatch({ type: 'SET_DOCUMENT_IN_CREATE_DATA', payload: data })
	}, [data]) // eslint-disable-line react-hooks/exhaustive-deps	

	const Option = props => {
		return (
			<div style={{
				padding: props.data.child ? '0 0 0 20px' : '0', color: '#999',
				fontWeight: props.data.parentId === 0 ? 'bold' : 'normal', fontSize: '.8rem'
			}}>
				<components.Option {...props} />
			</div>
		);
	};

	useEffect(() => {
		const handleKeyPress = (e) => {
			const active = document.activeElement;
			const isEditable =
				active &&
				(active.tagName === "INPUT" || active.tagName === "TEXTAREA") &&
				!active.disabled &&
				!active.readOnly;

			if (!isEditable) {
				// Agar hech qanday input fokusda bo'lmasa
				searchRef.current.focus();
			}
		};

		document.addEventListener("keydown", handleKeyPress);

		return () => {
			document.removeEventListener("keydown", handleKeyPress);
		};
	}, []);

	const GroupHead = props => {
		return (
			<div style={{
				padding: '0',
				color: '#999',
				fontWeight: 'bold',
				backgroundColor: '#fff',
				fontSize: '.8rem'
			}}>
				<components.Option {...props} />
			</div>
		);
	};

	return (
		<>
			{/* Mobile uchun to'liq ekran stillar */}
			{isMobile && (
				<style>{`
					.page-content { padding: 10px !important; }
					.container-fluid { padding: 0 !important; }
					.card { border-radius: 12px; box-shadow: 0 2px 8px rgba(0,0,0,0.08); }
					.card-body { padding: 16px !important; }
				`}</style>
			)}

			<div className="page-header d-flex justify-content-between mb-2">
				<div className="d-flex text-truncate">
					{isMobile ? (
						<>
							<Link to="/documents-in" className="vertical-center me-2">
								<i className="uil uil-angle-left fz-24"></i>
							</Link>
							<h4 className="vertical-center m-0">
								{t('GOOD_RECEPTION')}
							</h4>
						</>
					) : (
						<>
							<h4 className="vertical-center">
								{t('GOOD_RECEPTION')}
							</h4>
							<div className="vertical-center mt-1">
								<i className="uil uil-angle-double-right fz-20"></i>
							</div>
							<div className="vertical-center mt-1">
								<h6>{t('CREATE')}</h6>
							</div>
						</>
					)}
				</div>
				<div className="d-flex">
					<DropdownButton title={t('ACTION')} onSelect={saveToExcel}>
						<Dropdown.Item as="li" eventKey="1">
							<a href="/importDocument.xlsx" className="upload-from-excel">
								{t('DOWNLOAD_TEMPLATE')}
							</a>
						</Dropdown.Item>
						<Dropdown.Item as="li" eventKey="2">
							<input id="actual-btn" hidden type="file" onChange={importFromExel} accept=".csv, .xlsx, .xls, application/vnd.ms-excel" />
							<label htmlFor="actual-btn" className="upload-from-excel">{t('IMPORT_FROM_FILE_REVIEW')}</label>
						</Dropdown.Item>
						<Dropdown.Item as="li" eventKey="4">
							<input id="actual-btn-direct" hidden type="file" onChange={importFromExelDirect} accept=".csv, .xlsx, .xls, application/vnd.ms-excel" />
							<label htmlFor="actual-btn-direct" className="upload-from-excel">{t('IMPORT_FROM_FILE_DIRECT')}</label>
						</Dropdown.Item>
						<Dropdown.Item as="li" eventKey="3">
							<div className="cursor">{t('SAVE')}</div>
						</Dropdown.Item>
					</DropdownButton>
				</div>
			</div>

			<form autoComplete="off" style={{ padding: 0, margin: 0 }}>
				{/* MOBILE VERSION */}
				{isMobile ? (
					<>
						<div className="card mb-3">
							<div className="card-body">
								{/* Savdo nuqtasi */}
								<div className="form-group">
									<label>{t('POS')}<span className="required-mark">*</span></label>
									<Select
										isDisabled={data.productList.length > 0 || searchData.length > 0}
										options={poses}
										value={poses.find(option => option.id === data.posId)}
										onChange={(option) => setData({ ...data, 'posId': option.id })}
										placeholder=""
										noOptionsMessage={() => t('LIST_IS_EMPTY')}
										getOptionLabel={(option) => option.name}
										getOptionValue={(option) => option.id}
									/>
								</div>

								{/* Ta'minotchi */}
								<div className="form-group">
									<label>{t('SUPPLIER')}<span className="required-mark">*</span></label>
									<Select
										options={organizations}
										value={organizations.find(option => option.id === data.organizationId)}
										onChange={(option) => handleSelectOrganization(option)}
										placeholder=""
										noOptionsMessage={() => t('LIST_IS_EMPTY')}
										getOptionLabel={(option) => option.name}
										getOptionValue={(option) => option.id}
									/>
								</div>

								{/* Valyuta va To'lov uslubi */}
								<div className="row">
									<div className="col-6">
										<div className="form-group">
											<label>{t('CURRENCY')}<span className="required-mark">*</span></label>
											<Select
												isDisabled={data.productList.length > 0 || searchData.length > 0}
												options={currencies}
												value={currencies.find(option => option.id === data.currencyId)}
												onChange={(option) => setData({ ...data, 'currencyId': option.id })}
												placeholder=""
												noOptionsMessage={() => t('LIST_IS_EMPTY')}
												getOptionLabel={(option) => option.name}
												getOptionValue={(option) => option.id}
											/>
										</div>
									</div>
									<div className="col-6">
										<div className="form-group">
											<label>{t('PAYMENT_METHOD')}<span className="required-mark">*</span></label>
											<Select
												options={paymentTypes}
												value={paymentTypes.find(option => option.id === data.paymentTypeId)}
												onChange={(option) => setData({ ...data, 'paymentTypeId': option.id })}
												placeholder=""
												noOptionsMessage={() => t('LIST_IS_EMPTY')}
												getOptionLabel={(option) => option.name}
												getOptionValue={(option) => option.id}
											/>
										</div>
									</div>
								</div>

								{/* To'langan */}
								<div className="form-group">
									<label>{t('PAID')}<span className="required-mark">*</span></label>
									<Select
										options={paids}
										value={paids.find(option => option.id === data.paid)}
										onChange={(option) => setData({ ...data, 'paid': option.id })}
										placeholder=""
										noOptionsMessage={() => t('LIST_IS_EMPTY')}
										getOptionLabel={(option) => option.name}
										getOptionValue={(option) => option.id}
									/>
								</div>

								{/* Qo'shimcha ma'lumotlar - Collapse */}
								<div
									className="d-flex justify-content-between align-items-center cursor text-primary py-2"
									onClick={() => setShowAdditionalFields(!showAdditionalFields)}
								>
									<span>{t('ADDITIONAL_INFO') || "Qo'shimcha ma'lumotlar"}</span>
									<i className={`uil ${showAdditionalFields ? 'uil-angle-up' : 'uil-angle-down'} fz-20`}></i>
								</div>

								{showAdditionalFields && (
									<div className="mt-2">
										<div className="form-group">
											<label>{t('DEBT_PAYMENT_DATE')}</label>
											<input type="number" className="form-control"
												value={data.organizationDate}
												onChange={(e) => setData({ ...data, 'organizationDate': e.target.value })} />
										</div>

										<div className="form-group">
											<label>№ {t('OVERHEAD')}</label>
											<input type="text" className="form-control" onChange={(e) => setData({ ...data, 'inNumber': e.target.value })} />
										</div>

										{(reduxSettings.documentsInCreate?.wholesalePrice || !reduxSettings.documentsInCreate) &&
											<div className="form-group">
												<label>{t('MARKUP_WHOLESALEPRICE')}</label>
												<div className="input-group">
													<input type="number" className="form-control"
														onChange={(e) => setData({ ...data, 'wholesalePriceMarkup': e.target.value })} />
													<span className="input-group-text">%</span>
												</div>
											</div>
										}

										{(!reduxSettings.tableDocumentsInCreate || reduxSettings.tableDocumentsInCreate?.bankPrice) &&
											<div className="form-group">
												<label>{t('MARKUP_BANKPRICE')}</label>
												<div className="input-group">
													<input type="number" className="form-control"
														onChange={(e) => setData({ ...data, 'bankPriceMarkup': e.target.value })} />
													<span className="input-group-text">%</span>
												</div>
											</div>
										}

										<div className="form-group">
											<label>{t('MARKUP_SALE')}</label>
											<div className="input-group">
												<span className="input-group-text cursor" title={t('REVERSE_PRICE_HINT')}
													onClick={() => setReverseSalePrice(!reverseSalePrice)}>
													<input type="checkbox" className="me-1" checked={reverseSalePrice} readOnly />
													<b className={reverseSalePrice ? 'text-success' : ''}>R</b>
												</span>
												<input type="number" className="form-control"
													onChange={(e) => setData({ ...data, 'salePriceMarkup': e.target.value })} />
												<span className="input-group-text">%</span>
											</div>
										</div>

										{(reduxSettings.documentsInCreate?.vat || !reduxSettings.documentsInCreate) &&
											<div className="form-group">
												<label>{t('VAT')}</label>
												<input type="number" className="form-control"
													onChange={(e) => setData({ ...data, 'defaultVat': e.target.value })} />
											</div>
										}

										<div className="form-group">
											<label>{t('NOTE')}</label>
											<input className="form-control" onChange={(e) => setData({ ...data, 'note': e.target.value })} />
										</div>

										<div className="form-group">
											<label>{t('EXPENSES')}</label>
											<div className="input-group">
												<input type="number" className="form-control"
													onChange={(e) => setData({ ...data, expense: e.target.value })} value={data.expense} />
												<span className="input-group-text cursor" onClick={(e) => onChangePrice()}>
													<i className="uil uil-check-circle"></i>
												</span>
											</div>
										</div>
									</div>
								)}
							</div>
						</div>

						{/* Mahsulotlar ro'yxati - Mobile */}
						{data.productList.length > 0 && (
							<div className="card mb-3">
								<div className="card-body p-2">
									{/* Sarlavha va nastroyka */}
									<div className="d-flex justify-content-between align-items-center mb-2 pb-2 border-bottom">
										<strong>{t('PRODUCTS')}</strong>
										<i className="uil-setting fz-20 cursor text-primary" onClick={() => setModalTableControl(true)}></i>
									</div>
									{data.productList.map((item, index) => (
										<div key={index} className="border-bottom p-2 mb-2">
											{/* Mahsulot nomi va o'chirish tugmasi */}
											<div className="d-flex justify-content-between align-items-start mb-2">
												<div className="fw-bold">{index + 1}. {item.name}</div>
												<div className="d-flex gap-2">
													<div className="table-action-button table-action-primary-button" onClick={() => showProductUpdateModal(true, index)}>
														<i className="uil uil-edit"></i>
													</div>
													<div className="table-action-button table-action-danger-button" onClick={() => deleteProduct(index)}>
														<i className="uil uil-times"></i>
													</div>
												</div>
											</div>

											{/* Shtrix-kod va Qoldiq */}
											<div className="d-flex justify-content-between small text-muted mb-2">
												<span><strong>{t('BARCODE')}:</strong> {item.barcode}</span>
												<span><strong>{t('RESIDUE')}:</strong> {formatMoney(item.balance)} {item.uomName}</span>
											</div>

											{/* Artikul */}
											{(!reduxSettings.tableDocumentsInCreate || reduxSettings.tableDocumentsInCreate?.artikul) &&
												<div className="small text-muted mb-2">
													<strong>{t('ARTIKUL')}:</strong> {item.artikul || '-'}
												</div>
											}

											{/* Asosiy Inputlar */}
											<div className="row g-2 mb-2">
												<div className="col-4">
													<label className="small text-muted">{t('QUANTITY')}</label>
<input type="number" step="0.01" inputMode="decimal" className="form-control form-control-sm"
														name="quantity" value={item.quantity}
														onChange={(e) => handleProductListChange(e, index)} />
												</div>
												<div className="col-4">
													<label className="small text-muted">{t('ADMISSION_PRICE')}</label>
													<MoneyInput step="0.01" inputMode="decimal" className="form-control form-control-sm"
														name="price" value={item.price}
														onChange={(e) => handleProductListChange(e, index)} />
												</div>
												<div className="col-4">
													<label className="small text-muted">{t('UNIT_PRICE')}</label>
													<MoneyInput step="0.01" inputMode="decimal" className="form-control form-control-sm"
														name="salePrice" value={item.salePrice}
														onChange={(e) => handleProductListChange(e, index)} />
												</div>
											</div>

											{/* Qo'shimcha inputlar - nastroykaga qarab */}
											<div className="row g-2 mb-2">
												{/* Ulgurji narx */}
{(!reduxSettings.tableDocumentsInCreate || reduxSettings.tableDocumentsInCreate?.wholesalePrice) &&
													<div className="col-4">
														<label className="small text-muted">{t('WHOLESALE_PRICE')}</label>
														<MoneyInput step="0.01" inputMode="decimal" className="form-control form-control-sm"
															name="wholesalePrice" value={item.wholesalePrice}
															onChange={(e) => handleProductListChange(e, index)} />
													</div>
												}
												{/* Bank narxi / Transfer narxi */}
												{(!reduxSettings.tableDocumentsInCreate || reduxSettings.tableDocumentsInCreate?.bankPrice) &&
													<div className="col-4">
														<label className="small text-muted">{t('BANK_PRICE')}</label>
														<MoneyInput step="0.01" inputMode="decimal" className="form-control form-control-sm"
															name="bankPrice" value={item.bankPrice}
															onChange={(e) => handleProductListChange(e, index)} />
													</div>
												}
												{/* QQS */}
												{(!reduxSettings.tableDocumentsInCreate || reduxSettings.tableDocumentsInCreate?.vat) &&
													<div className="col-4">
														<label className="small text-muted">{t('VAT')}</label>
														<input type="number" step="0.01" inputMode="decimal" className="form-control form-control-sm"
															name="vat" value={item.vat}
															onChange={(e) => handleProductListChange(e, index)} />
													</div>
												}
											</div>

											{/* Seriya */}
											{(!reduxSettings.tableDocumentsInCreate || reduxSettings.tableDocumentsInCreate?.serial) &&
												<div className="mb-2">
													<label className="small text-muted">{t('SERIAL')}</label>
													<div>
														{item?.serialNumbers?.length === 0 ?
															<span className="badge bg-danger cursor" onClick={() => serialProductsModal(item)}>
																{t('NOT_SPECIFIED')}
															</span>
															:
															<span className="badge bg-primary cursor" onClick={() => serialProductsModal(item)}>
																{item?.serialNumbers?.length === 1 ? item?.serialNumbers[0] : t('SPECIFIED')}
															</span>
														}
													</div>
												</div>
											}

											{/* Muddati */}
											{(!reduxSettings.tableDocumentsInCreate || reduxSettings.tableDocumentsInCreate?.expDate) &&
												<div className="mb-2">
													<label className="small text-muted">{t('EXPIRATION_DATE')}</label>
													<DatePicker
														className="form-control form-control-sm"
														dateFormat="dd.MM.yyyy"
														selected={item.expDate ? new Date(item.expDate) : ''}
														onChange={(date) => handleExpDateChange(date, index)} />
												</div>
											}

											{/* Markirovka */}
											{(!reduxSettings.tableDocumentsInCreate || reduxSettings.tableDocumentsInCreate?.marking) &&
												<div className="d-flex justify-content-between small mb-2">
													<span className="text-muted">{t('MARKING')}:</span>
													{item.marking ?
														<span className="badge bg-primary">{t('YES')}</span>
														:
														<span className="badge bg-danger">{t('NO')}</span>
													}
												</div>
											}

											{/* Summa */}
											<div className="d-flex justify-content-end mt-2">
												<span className="fw-bold text-primary">
													{t('AMOUNT')}: {formatMoney(item.quantity * item.price)}
												</span>
											</div>
										</div>
									))}
								</div>
							</div>
						)}

						{/* Qidiruv va tugmalar - Mobile */}
						<div className="d-flex align-items-center gap-2 mb-3">
							<div className="form-group position-relative m-0 flex-grow-1">
								<DebounceInput
									inputRef={searchRef}
									disabled={!data.posId}
									value={search}
									onChange={(e) => searchProduct(e.target.value)}
									type="text"
									className="form-control"
									placeholder={t('SEARCH') + '...'}
									style={{ paddingRight: '70px' }}
									debounceTimeout={1000}
								/>
								{/* Plus va barcode ikonlari input ichida */}
								<div className="d-flex align-items-center" style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', gap: '8px' }}>
									<div style={{ width: '28px', height: '28px', borderRadius: '6px', backgroundColor: '#25B17B', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }} onClick={() => showProductCreateModal(true)}>
										<i className="uil uil-plus" style={{ color: '#fff', fontSize: '18px' }}></i>
									</div>
									{searchData.length > 0 ?
										<i className="uil uil-times fz-20 cursor" onClick={() => { setSearchData([]); setSearch('') }}></i>
										:
										<i className={'uil uil-qrcode-scan fz-20 cursor ' + (barcode && 'text-primary')} onClick={() => setBarcode(!barcode)}></i>
									}
								</div>

								{searchData.length > 0 &&
									<span className="dropdown-search-menu" style={{ bottom: '100%', top: 'auto', marginBottom: '5px' }}>
										<div className="dropdown-menu-list">
											<span className="dropdown-menu-result">
												<div className="p-2" style={{ maxHeight: '400px', overflowY: 'auto' }}>
													{searchData.map((item, index) => (
														<div key={index} className="border-bottom p-2 mb-2">
															<div className="d-flex justify-content-between align-items-start">
																<div className="flex-grow-1">
																	<div className="fw-bold mb-1">{item.name}</div>
																	<div className="d-flex flex-wrap gap-2 small text-muted">
																		<span><strong>{t('BARCODE')}:</strong> {item.barcode}</span>
																		<span><strong>{t('RESIDUE')}:</strong> {formatMoney(item.balance)} {item.uomName}</span>
																	</div>
																</div>
																{item.productShow && (
																	<div className="table-action-button table-action-primary-button ms-2" onClick={() => addToList(index)}>
																		<i className="uil uil-plus"></i>
																	</div>
																)}
															</div>
														</div>
													))}
													<Pagination pageCount={pageCount} paginate={paginate}></Pagination>
												</div>
											</span>
										</div>
									</span>
								}
								{(searchData.length === 0 && searchDataExist === 1) &&
									<span className="dropdown-search-menu" style={{ bottom: '100%', top: 'auto', marginBottom: '5px' }}>
										<div className="dropdown-menu-list d-flex justify-content-between p-2">
											<span className="dropdown-menu-result fz20">{t('PRODUCT_NOT_FOUND')}</span>
										</div>
									</span>
								}
								{(searchData.length >= 0 && searchDataExist === 2) &&
									<span className="dropdown-search-menu" style={{ bottom: '100%', top: 'auto', marginBottom: '5px' }}>
										<div className="dropdown-menu-list d-flex justify-content-between p-2">
											<span className="dropdown-menu-result fz20">{t('PRODUCT_ADDED')}</span>
										</div>
									</span>
								}
							</div>
							{/* Kamera scanner tugma */}
							<div style={{ width: '45px', height: '45px', borderRadius: '8px', flexShrink: 0, backgroundColor: '#25B17B', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }} onClick={() => setModalScanner(true)}>
								<i className="uil uil-capture" style={{ color: '#fff', fontSize: '22px' }}></i>
							</div>
						</div>

						{/* Summalar - Mobile */}
						<div className="card mb-3">
							<div className="card-body">
								<div className="d-flex justify-content-between mb-1">
									<span>{t('TOTAL_QUANTITY')}:</span>
									<strong>{formatMoney(totalAmount.totalQuantity)}</strong>
								</div>
								<div className="d-flex justify-content-between mb-1">
									<span>{t('RECEIPT_AMOUNT')}:</span>
									<strong>{formatMoney(totalAmount.totalIncome)} {data.currencyName}</strong>
								</div>
								<div className="d-flex justify-content-between">
									<span className="fw-bold">{t('SALE_AMOUNT')}:</span>
									<strong className="text-primary">{formatMoney(totalAmount.totalSale)} {data.currencyName}</strong>
								</div>
							</div>
						</div>

						{/* Tugmalar - Mobile */}
						<div className="d-flex gap-2">
							<Link className="btn btn-outline-danger btn-rounded flex-grow-1" to="/documents-in">
								{t('CANCEL')}
							</Link>
							<button type="button" className="btn btn-primary btn-rounded flex-grow-1"
								onClick={() => setModalConfirm(true)}
								disabled={!data.productList.length > 0}>
								{t('SAVE')}
							</button>
						</div>
					</>
				) : (
					/* DESKTOP VERSION */
					<>
						<div className="card mb-3">
							<div className="card-body position-relative">
								<div className="row">
									<div className="col-md-2">
										<div className="form-group">
											<label>{t('POS')}<span className="required-mark">*</span></label>
											<Select
												isDisabled={data.productList.length > 0 || searchData.length > 0}
												options={poses}
												value={poses.find(option => option.id === data.posId)}
												onChange={(option) => setData({ ...data, 'posId': option.id })}
												placeholder=""
												noOptionsMessage={() => t('LIST_IS_EMPTY')}
												getOptionLabel={(option) => option.name}
												getOptionValue={(option) => option.id}
											/>
										</div>
									</div>
									<div className="col-md-2">
										<div className="form-group">
											<label>{t('SUPPLIER')}<span className="required-mark">*</span></label>
											<Select
												options={organizations}
												value={organizations.find(option => option.id === data.organizationId)}
												onChange={(option) => handleSelectOrganization(option)}
												placeholder=""
												noOptionsMessage={() => t('LIST_IS_EMPTY')}
												getOptionLabel={(option) => option.name}
												getOptionValue={(option) => option.id}
											/>
										</div>
									</div>
									<div className="col-md-2">
										<div className="form-group">
											<label>{t('DEBT_PAYMENT_DATE')}</label>
											<input type="number" className="form-control"
												value={data.organizationDate}
												onChange={(e) => setData({ ...data, 'organizationDate': e.target.value })} />
										</div>
									</div>
									<div className="col-md-2">
										<div className="form-group">
											<label>{t('CURRENCY')}<span className="required-mark">*</span></label>
											<Select
												isDisabled={data.productList.length > 0 || searchData.length > 0}
												options={currencies}
												value={currencies.find(option => option.id === data.currencyId)}
												onChange={(option) => setData({ ...data, 'currencyId': option.id })}
												placeholder=""
												noOptionsMessage={() => t('LIST_IS_EMPTY')}
												getOptionLabel={(option) => option.name}
												getOptionValue={(option) => option.id}
											/>
										</div>
									</div>
									<div className="col-md-2">
										<div className="form-group">
											<label>{t('PAID')}<span className="required-mark">*</span></label>
											<Select
												options={paids}
												value={paids.find(option => option.id === data.paid)}
												onChange={(option) => setData({ ...data, 'paid': option.id })}
												placeholder=""
												noOptionsMessage={() => t('LIST_IS_EMPTY')}
												getOptionLabel={(option) => option.name}
												getOptionValue={(option) => option.id}
											/>
										</div>
									</div>
									<div className="col-md-2">
										<div className="form-group">
											<label>{t('PAYMENT_METHOD')}<span className="required-mark">*</span></label>
											<Select
												options={paymentTypes}
												value={paymentTypes.find(option => option.id === data.paymentTypeId)}
												onChange={(option) => setData({ ...data, 'paymentTypeId': option.id })}
												placeholder=""
												noOptionsMessage={() => t('LIST_IS_EMPTY')}
												getOptionLabel={(option) => option.name}
												getOptionValue={(option) => option.id}
											/>
										</div>
									</div>
									<div className="col-md-2">
										<div className="form-group">
											<label>№ {t('OVERHEAD')}</label>
											<input type="text" className="form-control" onChange={(e) => setData({ ...data, 'inNumber': e.target.value })} />
										</div>
									</div>
									{(reduxSettings.documentsInCreate?.wholesalePrice || !reduxSettings.documentsInCreate) &&
										<div className="col-md-2">
											<div className="form-group">
												<label>{t('MARKUP_WHOLESALEPRICE')}</label>
												<div className="mb-3 input-group">
													<input type="number" className="form-control"
														onChange={(e) => setData({ ...data, 'wholesalePriceMarkup': e.target.value })} />
													<span className="input-group-text">%</span>
												</div>
											</div>
										</div>
									}
									{(!reduxSettings.tableDocumentsInCreate || reduxSettings.tableDocumentsInCreate?.bankPrice) &&
										<div className="col-md-2">
											<div className="form-group">
												<label>{t('MARKUP_BANKPRICE')}</label>
												<div className="mb-3 input-group">
													<input type="number" className="form-control"
														onChange={(e) => setData({ ...data, 'bankPriceMarkup': e.target.value })} />
													<span className="input-group-text">%</span>
												</div>
											</div>
										</div>
									}
									<div className="col-md-2">
										<div className="form-group">
											<label>{t('MARKUP_SALE')}</label>
											<div className="mb-3 input-group">
												<span className="input-group-text cursor" title={t('REVERSE_PRICE_HINT')}
													onClick={() => setReverseSalePrice(!reverseSalePrice)}>
													<input type="checkbox" className="me-1" checked={reverseSalePrice} readOnly />
													<b className={reverseSalePrice ? 'text-success' : ''}>R</b>
												</span>
												<input type="number" className="form-control"
													onChange={(e) => setData({ ...data, 'salePriceMarkup': e.target.value })} />
												<span className="input-group-text">%</span>
											</div>
										</div>
									</div>
									{(reduxSettings.documentsInCreate?.vat || !reduxSettings.documentsInCreate) &&
										<div className="col-md-2">
											<div className="form-group">
												<label>{t('VAT')}</label>
												<input type="number" className="form-control"
													onChange={(e) => setData({ ...data, 'defaultVat': e.target.value })} />
											</div>
										</div>
									}
									<div className="col-md-2">
										<div className="form-group">
											<label>{t('NOTE')}</label>
											<input className="form-control" onChange={(e) => setData({ ...data, 'note': e.target.value })} />
										</div>
									</div>
									<div className="col-md-2">
										<div className="form-group">
											<label>{t('EXPENSES')}</label>
											<div className="mb-3 input-group">
												<input type="number" className="form-control"
													onChange={(e) => setData({ ...data, expense: e.target.value })} value={data.expense} />
												<span className="input-group-text cursor" onClick={(e) => onChangePrice()}>
													<i className="uil uil-check-circle"></i>
												</span>
											</div>
										</div>
									</div>
								</div>
								<div className="printer-icon">
									{data.productList.length > 0 &&
										<div className="d-flex align-items-center gap-2">
											<button type="button" className="table-action-button table-action-danger-button"
												title={t('DELETE_ALL')}
												onClick={() => setModalDeleteAllConfirm(true)}>
												<i className="uil-trash-alt"></i>
											</button>
											{printProducts.length > 0 &&
												<button type="button" className="table-action-button table-action-primary-button" onClick={(e) => {
													e.preventDefault()
													openPriceTagModal()
												}}>
													<i className="uil-print"></i>
												</button>
											}
										</div>
									}
								</div>
							</div>
						</div>

						<div className="card">
							<div className="card-body">
								<div className="table-responsive mb-3">
									<table className="table table-striped mb-0">
										<thead>
											<tr>
												<th className="text-center">

													<Form.Check // prettier-ignore
														type="checkbox"
														value={allSelected}
														checked={allSelected}
														onChange={() => handleAllSelected()}
													/>
												</th>
												<th>{t('NAME_OF_PRODUCT')}</th>
												<th className="text-center">{t('BARCODE')}</th>
												{(!reduxSettings.tableDocumentsInCreate || reduxSettings.tableDocumentsInCreate?.artikul) &&
													<th className="text-center">{t('ARTIKUL')}</th>
												}
												<th className="text-center">{t('RESIDUE')}</th>
												<th className="text-center">{t('QUANTITY')}</th>
												<th className="text-center">{t('UNIT')}</th>
												<th className="text-center">{t('ADMISSION_PRICE')}</th>
												{(!reduxSettings.tableDocumentsInCreate || reduxSettings.tableDocumentsInCreate?.wholesalePrice) &&
													<th className="text-center">{t('WHOLESALE_PRICE')}</th>
												}
												{(!reduxSettings.tableDocumentsInCreate || reduxSettings.tableDocumentsInCreate?.bankPrice) &&
													<th className="text-center">{t('BANK_PRICE')}</th>
												}
												<th className="text-center">{t('UNIT_PRICE')}</th>
												{(!reduxSettings.tableDocumentsInCreate || reduxSettings.tableDocumentsInCreate?.serial) &&
													<th className="text-center">{t('SERIAL')}</th>
												}
												{(!reduxSettings.tableDocumentsInCreate || reduxSettings.tableDocumentsInCreate?.expDate) &&
													<th className="text-center">{t('EXPIRATION_DATE')}</th>
												}
												{(!reduxSettings.tableDocumentsInCreate || reduxSettings.tableDocumentsInCreate?.vat) &&
													<th className="text-center">{t('VAT')}</th>
												}
												{(!reduxSettings.tableDocumentsInCreate || reduxSettings.tableDocumentsInCreate?.marking) &&
													<th className="text-center">{t('MARKING')}</th>
												}
												<th className="text-end">{t('AMOUNT')}</th>
												<th className="text-center table-control">
													<i className="uil-setting table-control-icon" onClick={() => setModalTableControl(true)}></i>
												</th>
											</tr>
										</thead>
										<tbody>
											{data.productList.map((item, index) => (
												<tr key={index} className="vertical-middle">
													<td className="text-center">
														<Form.Check // prettier-ignore
															type="checkbox"
															value={item.checked}
															checked={item.checked}
															onChange={() => handleChange(index)}
														/>
													</td>
													<td>{index + 1}. {item.name}</td>
													<td className="text-center">{item.barcode}</td>
													{(!reduxSettings.tableDocumentsInCreate || reduxSettings.tableDocumentsInCreate?.artikul) &&
														<td className="text-center">{item.artikul}</td>
													}
													<td className="text-center">{formatMoney(item.balance)}</td>
													<td className="text-center">
														<input type="text" className={"auto-width-input " + ((!item.serialNumbers?.length && !/^\d+(\.\d+)?$/.test(String(item.quantity ?? '').trim())) && "required-border")}
															disabled={item.serialNumbers?.length > 0}
															name="quantity" value={item.quantity}
															id={index + 1}
															tabIndex={index * 10 + 3}
															onChange={(e) => handleProductListChange(e, index)} />
													</td>
													<td className="text-center">{item.uomName}</td>
													<td className="text-center">
														<MoneyInput className={"auto-width-input " + ((Number(item.price) > 1000000000) && "required-border second")}
															name="price" value={item.price}
															tabIndex={index * 10 + 4}
															disabled={reduxSettings.documentsInCalculationByAmount}
															onChange={(e) => handleProductListChange(e, index)} />
													</td>
													{(!reduxSettings.tableDocumentsInCreate || reduxSettings.tableDocumentsInCreate?.wholesalePrice) &&
														<td className="text-center">
															<MoneyInput className={"auto-width-input " + (((Number(item.price) > Number(item.wholesalePrice)) || (Number(item.wholesalePrice) > 1000000000)) && "required-border second")}
																name="wholesalePrice" value={item.wholesalePrice}
																tabIndex={index * 10 + 5}
																onChange={(e) => handleProductListChange(e, index)} />
														</td>
													}
													{(!reduxSettings.tableDocumentsInCreate || reduxSettings.tableDocumentsInCreate?.bankPrice) &&
														<td className="text-center">
															<MoneyInput className={"auto-width-input " + (((Number(item.price) > Number(item.bankPrice)) || (Number(item.bankPrice) > 1000000000)) && "required-border second")}
																name="bankPrice" value={item.bankPrice}
																tabIndex={index * 10 + 5}
																onChange={(e) => handleProductListChange(e, index)} />
														</td>
													}
													<td className="text-center">
														<MoneyInput className={"auto-width-input " + (((Number(item.wholesalePrice) > Number(item.salePrice)) || (Number(item.salePrice) > 1000000000)) && "required-border second")}
															name="salePrice" value={item.salePrice}
															tabIndex={index * 10 + 6}
															onChange={(e) => handleProductListChange(e, index)}
														/>
													</td>
													{(!reduxSettings.tableDocumentsInCreate || reduxSettings.tableDocumentsInCreate?.serial) &&
														<td className="text-center">
															{item?.serialNumbers?.length === 0 ?
																<span className="bg-danger bg-border text-white text-nowrap cursor"
																	onClick={() => serialProductsModal(item)}>
																	{t('NOT_SPECIFIED')}
																</span>
																:
																<span className="bg-primary bg-border text-white text-nowrap cursor"
																	onClick={() => serialProductsModal(item)}>
																	{item?.serialNumbers?.length === 1 ?
																		<>{item?.serialNumbers[0]}</>
																		:
																		<>{t('SPECIFIED')}</>
																	}
																</span>
															}
														</td>
													}
													{(!reduxSettings.tableDocumentsInCreate || reduxSettings.tableDocumentsInCreate?.expDate) &&
														<td className="text-center">
															<DatePicker
																tabIndex="-1"
																className="auto-width-input"
																dateFormat="dd.MM.yyyy"
																selected={item.expDate ? new Date(item.expDate) : ''}
																onChange={(date) => handleExpDateChange(date, index)} />
														</td>
													}
													{(!reduxSettings.tableDocumentsInCreate || reduxSettings.tableDocumentsInCreate?.vat) &&
														<td className="text-center">
															<input type="number" min="0" className={"auto-width-input " + (item.vat === '' && "required-border")}
																name="vat" value={item.vat} tabIndex={index * 10 + 7}
																onChange={(e) => handleProductListChange(e, index)} />
														</td>
													}
													{(!reduxSettings.tableDocumentsInCreate || reduxSettings.tableDocumentsInCreate?.marking) &&
														<td className="text-center">
															{item.marking ?
																<span className="bg-primary bg-border text-white">{t('YES')}</span>
																:
																<span className="bg-danger bg-border text-white">{t('NO')}</span>
															}
														</td>
													}
													<td className="text-end">
														{reduxSettings.documentsInCalculationByAmount ?
															<MoneyInput min="0" className={"auto-width-input " + (!item.totalPrice && "required-border")}
																name="totalPrice" value={item.totalPrice} tabIndex={index * 10 + 7}
																onChange={(e) => handleProductListChange(e, index)} />
															:
															formatMoney(item.quantity * item.price)
														}
													</td>
													<td>
														<div className="d-flex justify-content-center gap-2">
															<div className="table-action-button table-action-primary-button"
																onClick={() => showProductUpdateModal(true, index)}>
																<i className="uil uil-edit"></i>
															</div>
															<div className="table-action-button table-action-danger-button" onClick={() => deleteProduct(index)}>
																<i className="uil uil-times"></i>
															</div>
														</div>
													</td>
												</tr>
											))}
										</tbody>
									</table>
								</div>

								<div className="row">
									<div className="col-md-6 vertical-center">
										<div className="d-flex align-items-center gap-2">
											<div className="form-group position-relative m-0 flex-grow-1">
												<DebounceInput
													inputRef={searchRef}
													disabled={!data.posId}
													tabIndex={data.productList.length * 10 + 7}
													//tabIndex={1}
													value={search}
													onChange={(e) => searchProduct(e.target.value)}
													onKeyUp={(e) => {
														if (e.keyCode === 13) {
															e.preventDefault()
															searchProduct(e.target.value)
														}
													}}
													type="text"
													className="form-control"
													placeholder={t('SEARCH') + '...'}
													debounceTimeout={1000}
												/>
												{searchData.length > 0 ?
													<i className="uil uil-times search-barcode" onClick={() => { setSearchData([]); setSearch('') }}></i>
													:
													<i className={'uil uil-qrcode-scan search-barcode ' + (barcode && 'text-primary')} onClick={() => setBarcode(!barcode)}></i>
												}

												{searchData.length > 0 &&
													<span className="dropdown-search-menu">
														<div className="dropdown-menu-list">
															<span className="dropdown-menu-result">
																<div className="table-responsive p-3">
																	<table className="table-striped table">
																		<thead>
																			<tr>
																				<th>{t('NAME_OF_PRODUCT')}</th>
																				<th className="text-center">{t('BARCODE')}</th>
																				<th className="text-center">{t('QUANTITY')}</th>
																				<th className="text-center">{t('ACTION')}</th>
																			</tr>
																		</thead>
																		<tbody>
																			{searchData.map((item, index) => (
																				<tr key={index}>
																					<td>{item.name}</td>
																					<td className="text-center">{item.barcode}</td>
																					<td className="text-center">{item.balance} {item.uomName}</td>
																					{item.productShow ?
																						<td className="d-flex justify-content-center" onClick={() => addToList(index)}>
																							<div className="table-action-button table-action-primary-button">
																								<i className="uil uil-plus"></i>
																							</div>
																						</td>
																						:
																						<div className="text-center text-danger">{t('CHOOSE_ANOTHER_CURRENCY')}</div>
																					}
																				</tr>
																			))
																			}
																		</tbody>
																	</table>

																	<Pagination pageCount={pageCount} paginate={paginate}></Pagination>
																</div>
															</span>
														</div>
													</span>
												}
												{(searchData.length === 0 && searchDataExist === 1) &&
													<span className="dropdown-search-menu">
														<div className="dropdown-menu-list d-flex justify-content-between p-2">
															<span className="dropdown-menu-result fz20">{t('PRODUCT_NOT_FOUND')}</span>
														</div>
													</span>
												}
												{(searchData.length >= 0 && searchDataExist === 2) &&
													<span className="dropdown-search-menu">
														<div className="dropdown-menu-list d-flex justify-content-between p-2">
															<span className="dropdown-menu-result fz20">{t('PRODUCT_ADDED')}</span>
														</div>
													</span>
												}

											</div>
											<div className="table-action-button table-action-primary-button" style={{ width: '40px', height: '40px', borderRadius: '8px' }} onClick={() => showProductCreateModal(true)}>
												<i className="uil uil-plus"></i>
											</div>
											{isMobile && (
												<div className="table-action-button table-action-primary-button" style={{ width: '40px', height: '40px', borderRadius: '8px' }} onClick={() => setModalScanner(true)}>
													<i className="uil uil-camera"></i>
												</div>
											)}
										</div>
									</div>
									<div className="col-md-6 d-flex justify-content-end">
										<div className="flex-column">
											<h5 className="d-flex justify-content-between mb-1"><strong className="me-2">{t('TOTAL_QUANTITY')}:</strong>{formatMoney(totalAmount.totalQuantity)}</h5>
											<h5 className="d-flex justify-content-between mb-1"><strong className="me-2">{t('RECEIPT_AMOUNT')}:</strong>{formatMoney(totalAmount.totalIncome)} {data.currencyName}</h5>
											<h5 className="d-flex justify-content-between"><strong className="me-2">{t('SALE_AMOUNT')}:</strong>{formatMoney(totalAmount.totalSale)} {data.currencyName}</h5>
										</div>
									</div>
								</div>

								<div className="btn-wrapper">
									<Link className="btn btn-warning btn-rounded btn-wide me-2" to="/documents-in" tabIndex="-1">
										{t('CANCEL')}
									</Link>
									<button type="button" className="btn btn-primary btn-rounded btn-wide btn-wide" tabIndex="-1"
										onClick={() => setModalConfirm(true)}
										disabled={!data.productList.length > 0}>
										{t('SAVE')}
									</button>
								</div>
							</div>
						</div>
					</>
				)}
			</form>

			{/* MODAL SERIAL */}
			<Modal show={modalSerialNumbers} animation={false} centered dialogClassName="update-modal-width" backdrop="static"
				onHide={() => setModalSerialNumbers(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('REGISTER_SERIAL_PRODUCT')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form autoComplete="false">
						<div className="mb-2">
							<strong>{t('NAME_OF_PRODUCT')}</strong>: {modalData.name} <br />
							<strong>{t('QUANTITY')}</strong>: {modalData.quantity} <br />
							<strong>{t('UNIT')}</strong>: {modalData.uomName} <br />
						</div>
						<div className="d-flex justify-content-between mb-2">
							<input type="text" className="form-control me-2" value={serialNumber} onChange={(e) => setSerialNumber(e.target.value)} autoFocus />
							<button className="btn btn-primary" onClick={() => addSerialNumber()} disabled={!serialNumber}>{t('ADD')}</button>
						</div>
						<table className="table-striped table">
							<thead>
								<tr>
									<th>№</th>
									<th>{t('SERIAL')}</th>
									<th></th>
								</tr>
							</thead>
							<tbody>
								{modalData?.serialNumbers?.map((item, index) => (
									<tr key={index}>
										<td>{index + 1}</td>
										<td>{item}</td>
										<td>
											<div className="d-flex justify-center">
												<div className="table-action-button table-action-danger-button mr-4" onClick={() => deleteSerialNumber(index)}>
													<i className="uil uil-trash-alt"></i>
												</div>
											</div>
										</td>
									</tr>
								))
								}
							</tbody>
						</table>
						<div className="d-flex w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100 me-2" onClick={() => setModalSerialNumbers(false)}>{t('CANCEL')}</button>
							<button type="button" className="btn btn-primary w-100" onClick={() => saveItemSerial()}>{t('SAVE')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL SERIAL */}

			{/* MODAL SETTINGS */}
			<Modal show={modalProductData} animation={false} size="sm" centered dialogClassName="update-modal-width" backdrop="static"
				onHide={() => closeProductDataModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('SETTINGS')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{reduxTransferData?.documentInCreateProduct &&
						<div>
							<div className="d-flex justify-content-between mb-2">
								<div className="vertical-center">
									ИКПУ
								</div>
								<div className="vertical-center">
									<input type="checkbox" name="gtin"
										onChange={(e) => handleChangeProductData(e)}
										checked={reduxTransferData['documentInCreateProduct']['gtin']} />
								</div>
							</div>
							<div className="d-flex justify-content-between mb-2">
								<div className="vertical-center">
									{t('ADDITIONAL_QUANTITY')}
								</div>
								<div className="vertical-center">
									<input type="checkbox" name="modQuantity"
										onChange={(e) => handleChangeProductData(e)}
										checked={reduxTransferData['documentInCreateProduct']['modQuantity']} />
								</div>
							</div>
							<div className="d-flex justify-content-between mb-2">
								<div className="vertical-center">
									{t('ADDITIONAL_UNIT_OF_MEASUREMENT')}
								</div>
								<div className="vertical-center">
									<input type="checkbox" name="modUomId"
										onChange={(e) => handleChangeProductData(e)}
										checked={reduxTransferData['documentInCreateProduct']['modUomId']} />
								</div>
							</div>
							<div className="d-flex justify-content-between mb-2">
								<div className="vertical-center">
									{t('SEASONALITY')}
								</div>
								<div className="vertical-center">
									<input type="checkbox" name="seasonal"
										onChange={(e) => handleChangeProductData(e)}
										checked={reduxTransferData['documentInCreateProduct']['seasonal']} />
								</div>
							</div>
							<div className="d-flex justify-content-between mb-2">
								<div className="vertical-center">
									{t('ARTIKUL')}
								</div>
								<div className="vertical-center">
									<input type="checkbox" name="artikul"
										onChange={(e) => handleChangeProductData(e)}
										checked={reduxTransferData['documentInCreateProduct']['artikul']} />
								</div>
							</div>
						</div>
					}
				</Modal.Body>
			</Modal>
			{/* MODAL SETTINGS */}

			{/* MODAL INSTANT CREATE PRODUCT */}
			<Modal show={modalProduct} animation={false} centered dialogClassName="update-modal-width" backdrop="static"
				onHide={() => showProductCreateModal(false)}>
				<Modal.Header closeButton>
					<div className="d-flex justify-content-between align-items-center w-100">
						<Modal.Title>{t('NEW_PRODUCT')}</Modal.Title>
						<i className="uil-setting cursor me-3 fz-20" onClick={() => showProductDataModal()}></i>
					</div>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={handleSubmit(createProduct)} autoComplete="off">
						<div className="form-group">
							<label>{t('NAME_OF_PRODUCT')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" name="name" {...register('name', { required: true })} autoFocus />
							<span className="text-danger text-sm">{errors.name?.type === 'required' && t('required')}</span>
						</div>
						<div className="form-group">
							<label>{t('BARCODE')}<span className="required-mark">*</span></label>
							<div className="position-relative">
								<input type="number" className="form-control" name="barcode" {...register('barcode', { required: true })}
									onKeyUp={(e) => {
										if (e.keyCode === 13) {
											e.preventDefault()
											searchProduct(e.target.value, 'add')
										}
										if (e.key === 'ArrowUp') {
											generateRandomBarcode()
										}
									}}
									onChange={(e) => searchProduct(e.target.value, 'add')}
								/>
								<span className="text-danger text-sm">{errors.barcode?.type === 'required' && t('required')}</span>
								<i className="uil-sync input-right-icon"
									style={{ right: '30px' }}
									onClick={() => generateRandomBarcode()}></i>
								<i className="uil uil-shield-check input-right-icon" onClick={searchOfdProduct}></i>
							</div>
						</div>
						<div className="form-group">
							<label>{t('CATEGORY')}</label>
							<Controller
								name="categoryId"
								control={control}
								render={({ field }) =>
									<Select
										{...field}
										components={{ GroupHeading: GroupHead, Option, }}
										classNamePrefix="react-select"
										options={categories}
										value={categoriesInitial.find(option => option.id === getValues('categoryId'))}
										onChange={(e) => setValue('categoryId', e.id)}
										placeholder=""
										noOptionsMessage={() => t('LIST_IS_EMPTY')}
										getOptionLabel={(option) => option.label}
										getOptionValue={(option) => option.id}
									/>}
							/>
							<span className="text-danger text-sm">{errors.categoryId?.type === 'required' && t('required')}</span>
						</div>
						<div className="form-group">
							<label>{t('UNIT_OF_MEASUREMENT')}</label>
							<Controller
								name="uomId"
								control={control}
								render={({ field }) =>
									<Select
										{...field}
										options={uoms}
										value={uoms.find(option => option.id === getValues('uomId')) || ''}
										onChange={(e) => setValue('uomId', e.id)}
										placeholder=""
										noOptionsMessage={() => t('LIST_IS_EMPTY')}
										getOptionLabel={(option) => option.name}
										getOptionValue={(option) => option.id}
									/>}
							/>
							<span className="text-danger text-sm">{errors.categoryId?.type === 'required' && t('required')}</span>
						</div>
						{reduxTransferData?.documentInCreateProduct?.gtin &&
							<div className="form-group">
								<label>ИКПУ</label>
								<input type="number" className="form-control" name="gtin" {...register('gtin')} />
								<span className="text-danger text-sm">{errors.gtin?.message}</span>
							</div>
						}
						{reduxTransferData?.documentInCreateProduct?.modQuantity &&
							<div className="form-group">
								<label>{t('ADDITIONAL_QUANTITY')}</label>
								<input type="number" step="0.0001" className="form-control" name="modQuantity" {...register('modQuantity')} />
								<span className="text-danger text-sm">{errors.modQuantity?.message}</span>
							</div>
						}
						{reduxTransferData?.documentInCreateProduct?.modUomId &&
							<div className="form-group">
								<label>{t('ADDITIONAL_UNIT_OF_MEASUREMENT')}</label>
								<Controller
									name="modUomId"
									control={control}
									render={({ field }) =>
										<Select
											//isDisabled={id}
											tabIndex={3}
											{...field}
											options={uoms}
											value={uoms.find(option => option.id === getValues('modUomId'))}
											onChange={(e) => setValue('modUomId', e.id)}
											placeholder=""
											noOptionsMessage={() => t('LIST_IS_EMPTY')}
											getOptionLabel={(option) => option.name}
											getOptionValue={(option) => option.id}
										/>}
								/>
								<span className="text-danger text-sm">{errors.modUomId?.message}</span>
							</div>
						}
						{reduxTransferData?.documentInCreateProduct?.seasonal &&
							<div className="form-group">
								<label>{t('SEASONALITY')}</label>
								<Controller
									name="seasonal"
									control={control}
									render={({ field }) =>
										<Select
											//isDisabled={id}
											tabIndex={3}
											{...field}
											options={seasons}
											value={seasons.find(option => option.id === getValues('seasonal'))}
											onChange={(e) => setValue('seasonal', e.id)}
											placeholder=""
											noOptionsMessage={() => t('LIST_IS_EMPTY')}
											getOptionLabel={(option) => option.name}
											getOptionValue={(option) => option.id}
										/>}
								/>
								<span className="text-danger text-sm">{errors.seasonal?.message}</span>
							</div>
						}
						{reduxTransferData?.documentInCreateProduct?.artikul &&
							<div className="form-group">
								<label>{t('ARTIKUL')}</label>
								<input type="text" className="form-control" name="artikul" {...register('artikul')} />
								<span className="text-danger text-sm">{errors.artikul?.message}</span>
							</div>
						}
						<div className="d-flex w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100 me-2"
								onClick={() => showProductCreateModal(false)} tabIndex="-1">{t('CANCEL')}</button>
							<button type="submit" className="btn btn-primary w-100">{t('SAVE')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL INSTANT CREATE PRODUCT */}

			{/* MODAL INSTANT UPDATE PRODUCT */}
			<Modal show={modalUpdateProduct} animation={false} centered dialogClassName="update-modal-width"
				backdrop="static" onHide={() => showProductUpdateModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('PRODUCT')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={changeProduct} autoComplete="off">
						<div className="form-group">
							<label>{t('NAME_OF_PRODUCT')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" name="name" autoFocus
								value={selectedItem.name}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'name': e.target.value })} />
						</div>
						<div className="form-group">
							<label>{t('CATEGORY')}</label>
							<Select
								components={{ Option }}
								classNamePrefix="react-select"
								options={categories}
								value={categoriesInitial.find(option => option.id === selectedItem.categoryId)}
								onChange={(option) => setSelectedItem({ ...selectedItem, 'categoryId': option.id })}
								placeholder=""
								noOptionsMessage={() => t('LIST_IS_EMPTY')}
								getOptionLabel={(option) => option.label}
								getOptionValue={(option) => option.id}
							/>
						</div>
						<div className="form-group">
							<label>{t("ARTIKUL")}</label>
							<input type="text" className="form-control" name="artikul"
								value={selectedItem.artikul}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'artikul': e.target.value })} />
						</div>
						<div className="d-flex w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100 me-2"
								onClick={() => showProductUpdateModal(false)} tabIndex="-1">{t('CANCEL')}</button>
							<button type="submit" className="btn btn-primary w-100">{t('SAVE')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL INSTANT UPDATE PRODUCT */}

			{/* MODAL INSTANT CREATE SUPPLIER */}
			<Modal show={modalOrganization} animation={false} centered dialogClassName="update-modal-width" backdrop="static" onHide={() => showOrganizationCreateModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('SUPPLIER')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={handleSubmit2(createOrganization)} autoComplete="off">
						<div className="form-group">
							<label>{t('TITLE')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" name="name" {...register2('name', { required: true })} autoFocus />
							<span className="text-danger text-sm">{errors2.name?.type === 'required' && t('required')}</span>
						</div>
						<div className="form-group">
							<label>{t('PHONE')}</label>
							<div className="input-group">
								<span className="input-group-text">998</span>
								<input type="number" className="form-control" name="phone" {...register2('phone', { required: true, maxLength: 9, minLength: 9 })} />
							</div>
							<span className="text-danger text-sm">{errors2.phone?.type === 'required' && t('required')}</span>
							<span className="text-danger text-sm">{errors2.phone?.type === 'minLength' && t('min', { length: 9 })}</span>
							<span className="text-danger text-sm">{errors2.phone?.type === 'maxLength' && t('max', { length: 9 })}</span>
						</div>
						<div className="d-flex w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100 me-2"
								onClick={() => showOrganizationCreateModal(false)} tabIndex="-1">{t('CANCEL')}</button>
							<button type="submit" className="btn btn-primary w-100">{t('SAVE')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL INSTANT CREATE SUPPLIER */}

			{/* MODAL CONFIRM */}
			<Modal show={modalConfirm} animation={false} centered dialogClassName="update-modal-width" backdrop="static" onHide={() => setModalConfirm(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('CONFIRM')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="d-flex justify-content-between mb-2">
						<div>{t('POS')}</div>
						<div className="fw-700">{findFromArrayById(poses, data.posId)}</div>
					</div>
					<div className="d-flex justify-content-between mb-2">
						<div>{t('SUPPLIER')}</div>
						<div className="fw-700">{findFromArrayById(organizations, data.organizationId)}</div>
					</div>
					<div className="d-flex justify-content-between mb-2">
						<div>{t('CURRENCY')}</div>
						<div className="fw-700">{findFromArrayById(currencies, data.currencyId)}</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<div className="d-flex w-100">
						<button className="btn btn-warning w-100 me-2" onClick={() => setModalConfirm(false)}>
							{t('CANCEL')}
						</button>
						<button className="btn btn-primary w-100" onClick={(e) => createUpdate(e)}>{t('CONFIRM')}</button>
					</div>
				</Modal.Footer>
			</Modal>
			{/* MODAL CONFIRM */}

			{/* MODAL TABLE CONTROL */}
			<TableControl
				modalTableControl={modalTableControl}
				setModalTableControl={setModalTableControl}
				keyName={'tableDocumentsInCreate'}>
			</TableControl>
			{/* MODAL TABLE CONTROL */}

			{/* MODAL PRICE TAG */}
			<Modal show={modalPriceTag} animation={false} centered dialogClassName="custom-modal-width" backdrop="static"
				onHide={() => setModalPriceTag(false)} size="lg">
				<Modal.Header closeButton>
					<Modal.Title>{t('CONFIRM')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="card h-table-price-tags2 position-relative">
						<div className="card-body">
							<div className="table-responsive mb-4" style={{ maxHeight: '500px' }}>
								<table className="table table-striped mb-0">
									<thead>
										<tr>
											<th className="text-center">
												<Form.Check // prettier-ignore
													type="checkbox"
													value={allSelected}
													checked={allSelected}
													onChange={() => handleAllSelected()}
												/>
											</th>
											<th>{t('NAME_OF_PRODUCT')}</th>
											<th className="text-center">{t('BARCODE')}</th>
											<th className="text-center">{t('RESIDUE')}</th>
											<th className="text-center">{t('QUANTITY')}</th>
											<th className="text-center">{t('UNIT')}</th>
											<th className="text-center">{t('ADMISSION_PRICE')}</th>
											{(!reduxSettings.tableDocumentsInCreate || reduxSettings.tableDocumentsInCreate?.wholesalePrice) &&
												<th className="text-center">{t('WHOLESALE_PRICE')}</th>
											}
											<th className="text-center">{t('UNIT_PRICE')}</th>
											{(!reduxSettings.tableDocumentsInCreate || reduxSettings.tableDocumentsInCreate?.serial) &&
												<th className="text-center">{t('SERIAL')}</th>
											}
											{(!reduxSettings.tableDocumentsInCreate || reduxSettings.tableDocumentsInCreate?.expDate) &&
												<th className="text-center">{t('EXPIRATION_DATE')}</th>
											}
											{(!reduxSettings.tableDocumentsInCreate || reduxSettings.tableDocumentsInCreate?.vat) &&
												<th className="text-center">{t('VAT')}</th>
											}
											<th className="text-center table-control">
												<i className="uil-setting table-control-icon" onClick={() => setModalTableControl(true)}></i>
												{t('ACTION')}
											</th>
										</tr>
									</thead>
									<tbody>
										{data.productList.map((item, index) => (
											<tr key={index} className="vertical-middle">
												<td className="text-center">
													<Form.Check // prettier-ignore
														type="checkbox" value={item.checked}
														checked={item.checked}
														onChange={() => handleChange(index)}
													/>
												</td>
												<td>{index + 1}. {item.name}</td>
												<td className="text-center">{item.barcode}</td>
												<td className="text-center">{formatMoney(item.balance)}</td>
												<td className="text-center">
													<input type="text" className={"auto-width-input " + (!item.printQuantity && "required-border")}
														disabled={item.serialNumbers?.length > 0}
														name="printQuantity"
														value={item.printQuantity}
														id={index + 1}
														tabIndex={index * 10 + 3}
														onChange={(e) => handleProductListChange(e, index)} />
												</td>
												<td className="text-center">{item.uomName}</td>
												<td className="text-center">
													<MoneyInput className="auto-width-input"
														name="price" value={item.price}
														tabIndex={index * 10 + 4}
														onChange={(e) => handleProductListChange(e, index)} />
												</td>
												{(!reduxSettings.tableDocumentsInCreate || reduxSettings.tableDocumentsInCreate?.wholesalePrice) &&
													<td className="text-center">
														<MoneyInput className={"auto-width-input " + ((Number(item.price) > Number(item.wholesalePrice)) && "required-border")}
															name="wholesalePrice" value={item.wholesalePrice}
															tabIndex={index * 10 + 5}
															onChange={(e) => handleProductListChange(e, index)} />
													</td>
												}
												<td className="text-center">
													<MoneyInput className={"auto-width-input " + ((Number(item.wholesalePrice) > Number(item.salePrice)) && "required-border")}
														name="salePrice" value={item.salePrice}
														tabIndex={index * 10 + 6}
														onChange={(e) => handleProductListChange(e, index)}
													/>
												</td>
												{(!reduxSettings.tableDocumentsInCreate || reduxSettings.tableDocumentsInCreate?.serial) &&
													<td className="text-center">
														{item?.serialNumbers?.length === 0 ?
															<span className="bg-danger bg-border text-white text-nowrap cursor"
																onClick={() => serialProductsModal(item)}>
																{t('NOT_SPECIFIED')}
															</span>
															:
															<span className="bg-primary bg-border text-white text-nowrap cursor"
																onClick={() => serialProductsModal(item)}>
																{item?.serialNumbers?.length === 1 ?
																	<>{item?.serialNumbers[0]}</>
																	:
																	<>{t('SPECIFIED')}</>
																}
															</span>
														}
													</td>
												}
												{(!reduxSettings.tableDocumentsInCreate || reduxSettings.tableDocumentsInCreate?.expDate) &&
													<td className="text-center">
														<DatePicker
															tabIndex="-1"
															className="auto-width-input"
															dateFormat="dd.MM.yyyy"
															selected={item.expDate ? new Date(item.expDate) : ''}
															onChange={(date) => handleExpDateChange(date, index)} />
													</td>
												}
												{(!reduxSettings.tableDocumentsInCreate || reduxSettings.tableDocumentsInCreate?.vat) &&
													<td className="text-center">
														<input type="number" min="0" className={"auto-width-input " + (item.vat === '' && "required-border")}
															name="vat" value={item.vat} tabIndex="-1"
															onChange={(e) => handleProductListChange(e, index)} />
													</td>
												}
												<td>
													<div className="d-flex">
														<div className="table-action-button table-action-danger-button ms-2" onClick={() => deleteProduct(index)}>
															<i className="uil uil-times"></i>
														</div>
													</div>
												</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
							<div className="h-table-price-tags2 position-relative">
								<div className="h-table-price-tags3">
									<h6 className="mb-2">{t('price_tag')} (60х40 мм)</h6>
									<PriceTag60x40
										cashbox={cashbox}
										data={printProducts[printProducts.length - 1]}
										selectedPriceTag={selectedPriceTag}
										selectPriceTag={selectPriceTag}
										printProducts={printProducts}
										printRef={printRef}>
									</PriceTag60x40>
									<h6 className="mb-2">{t('price_tag')} (60х30 мм)</h6>
									<PriceTag60x30
										cashbox={cashbox}
										data={printProducts[printProducts.length - 1]}
										selectedPriceTag={selectedPriceTag}
										selectPriceTag={selectPriceTag}
										printProducts={printProducts}
										printRef={printRef}
										activateWholeSalePrice={false}>
									</PriceTag60x30>
									<h6 className="mb-2">{t('price_tag')} (40x30 мм)</h6>
									<PriceTag40x30
										cashbox={cashbox}
										data={printProducts[printProducts.length - 1]}
										selectedPriceTag={selectedPriceTag}
										selectPriceTag={selectPriceTag}
										printProducts={printProducts}
										printRef={printRef}
										activateWholeSalePrice={false}>
									</PriceTag40x30>
									<h6 className="mb-2">{t('price_tag')} (30x20 мм)</h6>
									<PriceTag30x20
										cashbox={cashbox}
										data={printProducts[printProducts.length - 1]}
										selectedPriceTag={selectedPriceTag}
										selectPriceTag={selectPriceTag}
										printProducts={printProducts}
										printRef={printRef}
										activateWholeSalePrice={false}
									>
									</PriceTag30x20>
								</div>
							</div>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<div className="d-flex w-100">
						<button className="btn btn-warning w-100 me-2" onClick={() => setModalPriceTag(false)}>
							{t('CANCEL')}
						</button>
						<button className="btn btn-primary w-100" onClick={() => prevHandlePrint()}>{t('print')}</button>
					</div>
				</Modal.Footer>
			</Modal>
			{/* MODAL PRICE TAG */}

			{/* MODAL CONFIRM */}
			<ConfirmModal modalConfirm={modalDeleteAllConfirm} setModalConfirm={setModalDeleteAllConfirm}
				confrim={deleteAllProduct} description={t('ARE_YOU_SURE_YOU_WANT_DELETE_ALL')} />
			{/* MODAL CONFIRM */}

			{/* MODAL MOBILE SCANNER */}
			<Modal show={modalScanner} animation={false} centered onHide={() => { setModalScanner(false); setScannerZoom(1); }}>
				<Modal.Header closeButton>
					<Modal.Title>{t('SCAN_BARCODE') || 'Shtrix-kodni skanerlash'}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div style={{ width: '100%', height: '300px', overflow: 'hidden', position: 'relative' }}>
						<div style={{ width: '100%', height: '100%', transform: `scale(${scannerZoom})`, transformOrigin: 'center center' }}>
							<Scanner
								onScan={(result) => {
									if (result && result.length > 0) {
										const scannedValue = result[0].rawValue
										setSearch(scannedValue)
										searchProduct(scannedValue)
										setModalScanner(false)
										setScannerZoom(1)
										toast.success(t('SCANNED_SUCCESSFULLY') || 'Muvaffaqiyatli skanerlandi!')
									}
								}}
								onError={(error) => console.log(error?.message)}
								formats={['code_128', 'code_39', 'ean_13', 'ean_8', 'upc_a', 'upc_e', 'itf', 'data_matrix', 'aztec']}
								scanDelay={0}
								constraints={{ facingMode: 'environment' }}
								styles={{
									container: { width: '100%', height: '100%' },
									video: { width: '100%', height: '100%', objectFit: 'cover' }
								}}
							/>
						</div>
					</div>
					{/* Zoom Controls */}
					<div className="d-flex justify-content-center align-items-center gap-3 mt-3">
						<button
							type="button"
							className="btn btn-outline-secondary"
							style={{ width: '50px', height: '50px', fontSize: '24px', borderRadius: '50%' }}
							onClick={() => setScannerZoom(prev => Math.max(1, prev - 0.5))}
							disabled={scannerZoom <= 1}
						>
							<i className="uil uil-minus"></i>
						</button>
						<span style={{ minWidth: '60px', textAlign: 'center', fontSize: '18px', fontWeight: 'bold' }}>{scannerZoom}x</span>
						<button
							type="button"
							className="btn btn-outline-secondary"
							style={{ width: '50px', height: '50px', fontSize: '24px', borderRadius: '50%' }}
							onClick={() => setScannerZoom(prev => Math.min(4, prev + 0.5))}
							disabled={scannerZoom >= 4}
						>
							<i className="uil uil-plus"></i>
						</button>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button className="btn btn-warning w-100" onClick={() => { setModalScanner(false); setScannerZoom(1); }}>
						{t('CANCEL')}
					</button>
				</Modal.Footer>
			</Modal>
			{/* MODAL MOBILE SCANNER */}
		</>
	)
}

export default CreateUpdate

